var items = {
  "block.minecraft.acacia_button": "Boton di agacie",
  "block.minecraft.acacia_door": "Puarte di agacie",
  "block.minecraft.acacia_fence": "Stangjaçade di agacie",
  "block.minecraft.acacia_fence_gate": "Portonut di agacie",
  "block.minecraft.acacia_hanging_sign": "Insegne di agacie",
  "block.minecraft.acacia_leaves": "Fueis di agacie",
  "block.minecraft.acacia_log": "Tronc di agacie",
  "block.minecraft.acacia_planks": "Breis di agacie",
  "block.minecraft.acacia_pressure_plate": "Plache di pression di agacie",
  "block.minecraft.acacia_sapling": "Arbossit di agacie",
  "block.minecraft.acacia_shelf": "Scansie di agacie",
  "block.minecraft.acacia_sign": "Cartel di agacie",
  "block.minecraft.acacia_slab": "Lastre di agacie",
  "block.minecraft.acacia_stairs": "Scjalins di agacie",
  "block.minecraft.acacia_trapdoor": "Trabuchel di agacie",
  "block.minecraft.acacia_wall_hanging_sign": "Insegne di parêt di agacie",
  "block.minecraft.acacia_wall_sign": "Targhe di parêt di agacie",
  "block.minecraft.acacia_wood": "Len di agacie",
  "block.minecraft.activator_rail": "Sinis di ativazion",
  "block.minecraft.air": "Aiar",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloc di ametiste",
  "block.minecraft.amethyst_cluster": "Agregât di ametiste",
  "block.minecraft.ancient_debris": "Rudinaçs antîcs",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Lastre di andesite",
  "block.minecraft.andesite_stairs": "Scjalins di andesite",
  "block.minecraft.andesite_wall": "Muret di andesite",
  "block.minecraft.anvil": "Incuin",
  "block.minecraft.attached_melon_stem": "Stoc di angurie tacât",
  "block.minecraft.attached_pumpkin_stem": "Stoc de coce tacât",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Fueis di azalee",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambù",
  "block.minecraft.bamboo_block": "Bloc di bambù",
  "block.minecraft.bamboo_button": "Boton di bambù",
  "block.minecraft.bamboo_door": "Puarte di bambù",
  "block.minecraft.bamboo_fence": "Stangjaçade di bambù",
  "block.minecraft.bamboo_fence_gate": "Portonut di bambù",
  "block.minecraft.bamboo_hanging_sign": "Insegne di bambù",
  "block.minecraft.bamboo_mosaic": "Bambù instreçât",
  "block.minecraft.bamboo_mosaic_slab": "Lastre di bambù instreçât",
  "block.minecraft.bamboo_mosaic_stairs": "Scjalins di bambù instreçât",
  "block.minecraft.bamboo_planks": "Breis di bambù",
  "block.minecraft.bamboo_pressure_plate": "Plache di pression di bambù",
  "block.minecraft.bamboo_sapling": "Menade di bambù",
  "block.minecraft.bamboo_shelf": "Scansie di bambù",
  "block.minecraft.bamboo_sign": "Cartel di bambù",
  "block.minecraft.bamboo_slab": "Lastre di bambù",
  "block.minecraft.bamboo_stairs": "Scjalins di bambù",
  "block.minecraft.bamboo_trapdoor": "Trabuchel di bambù",
  "block.minecraft.bamboo_wall_hanging_sign": "Insegne di parêt di bambù",
  "block.minecraft.bamboo_wall_sign": "Targhe di parêt di bambù",
  "block.minecraft.banner.base.black": "Cjamp neri",
  "block.minecraft.banner.base.blue": "Cjamp blu",
  "block.minecraft.banner.base.brown": "Cjamp maron",
  "block.minecraft.banner.base.cyan": "Cjamp ciano",
  "block.minecraft.banner.base.gray": "Cjamp grîs",
  "block.minecraft.banner.base.green": "Cjamp vert",
  "block.minecraft.banner.base.light_blue": "Cjamp blu clâr",
  "block.minecraft.banner.base.light_gray": "Cjamp grîs clâr",
  "block.minecraft.banner.base.lime": "Cjamp vert limon",
  "block.minecraft.banner.base.magenta": "Cjamp magenta",
  "block.minecraft.banner.base.orange": "Cjamp naranç",
  "block.minecraft.banner.base.pink": "Cjamp rose",
  "block.minecraft.banner.base.purple": "Cjamp viole",
  "block.minecraft.banner.base.red": "Cjamp ros",
  "block.minecraft.banner.base.white": "Cjamp blanc",
  "block.minecraft.banner.base.yellow": "Cjamp zâl",
  "block.minecraft.banner.border.black": "Ae bordure di neri",
  "block.minecraft.banner.border.blue": "Ae bordure di blu",
  "block.minecraft.banner.border.brown": "Ae bordure di maron",
  "block.minecraft.banner.border.cyan": "Ae bordure di ciano",
  "block.minecraft.banner.border.gray": "Ae bordure di grîs",
  "block.minecraft.banner.border.green": "Ae bordure di vert",
  "block.minecraft.banner.border.light_blue": "Ae bordure di blu clâr",
  "block.minecraft.banner.border.light_gray": "Ae bordure di grîs clâr",
  "block.minecraft.banner.border.lime": "Ae bordure di vert limon",
  "block.minecraft.banner.border.magenta": "Ae bordure di magenta",
  "block.minecraft.banner.border.orange": "Ae bordure di naranç",
  "block.minecraft.banner.border.pink": "Ae bordure di rose",
  "block.minecraft.banner.border.purple": "Ae bordure di viole",
  "block.minecraft.banner.border.red": "Ae bordure di ros",
  "block.minecraft.banner.border.white": "Ae bordure di blanc",
  "block.minecraft.banner.border.yellow": "Ae bordure di zâl",
  "block.minecraft.banner.bricks.black": "Semenât di modons di neri",
  "block.minecraft.banner.bricks.blue": "Semenât di modons di blu",
  "block.minecraft.banner.bricks.brown": "Semenât di modons di maron",
  "block.minecraft.banner.bricks.cyan": "Semenât di modons di ciano",
  "block.minecraft.banner.bricks.gray": "Semenât di modons di grîs",
  "block.minecraft.banner.bricks.green": "Semenât di modons di vert",
  "block.minecraft.banner.bricks.light_blue": "Semenât di modons di blu clâr",
  "block.minecraft.banner.bricks.light_gray": "Semenât di modons di grîs clâr",
  "block.minecraft.banner.bricks.lime": "Semenât di modons di vert limon",
  "block.minecraft.banner.bricks.magenta": "Semenât di modons di magenta",
  "block.minecraft.banner.bricks.orange": "Semenât di modons di naranç",
  "block.minecraft.banner.bricks.pink": "Semenât di modons di rose",
  "block.minecraft.banner.bricks.purple": "Semenât di modons di viole",
  "block.minecraft.banner.bricks.red": "Semenât di modons di ros",
  "block.minecraft.banner.bricks.white": "Semenât di modons di blanc",
  "block.minecraft.banner.bricks.yellow": "Semenât di modons di zâl",
  "block.minecraft.banner.circle.black": "Ae torte di neri",
  "block.minecraft.banner.circle.blue": "Ae torte di blu",
  "block.minecraft.banner.circle.brown": "Ae torte di maron",
  "block.minecraft.banner.circle.cyan": "Ae torte di ciano",
  "block.minecraft.banner.circle.gray": "Ae torte di grîs",
  "block.minecraft.banner.circle.green": "Ae torte di vert",
  "block.minecraft.banner.circle.light_blue": "Ae torte di blu clâr",
  "block.minecraft.banner.circle.light_gray": "Ae torte di grîs clâr",
  "block.minecraft.banner.circle.lime": "Ae torte di vert limon",
  "block.minecraft.banner.circle.magenta": "Ae torte di magenta",
  "block.minecraft.banner.circle.orange": "Ae torte di naranç",
  "block.minecraft.banner.circle.pink": "Ae torte di rose",
  "block.minecraft.banner.circle.purple": "Ae torte di viole",
  "block.minecraft.banner.circle.red": "Ae torte di ros",
  "block.minecraft.banner.circle.white": "Ae torte di blanc",
  "block.minecraft.banner.circle.yellow": "Ae torte di zâl",
  "block.minecraft.banner.creeper.black": "Ae muse di creeper di neri",
  "block.minecraft.banner.creeper.blue": "Ae muse di creeper di blu",
  "block.minecraft.banner.creeper.brown": "Ae muse di creeper di maron",
  "block.minecraft.banner.creeper.cyan": "Ae muse di creeper di ciano",
  "block.minecraft.banner.creeper.gray": "Ae muse di creeper di grîs",
  "block.minecraft.banner.creeper.green": "Ae muse di creeper di vert",
  "block.minecraft.banner.creeper.light_blue": "Ae muse di creeper di blu clâr",
  "block.minecraft.banner.creeper.light_gray": "Ae muse di creeper di grîs clâr",
  "block.minecraft.banner.creeper.lime": "Ae muse di creeper di vert limon",
  "block.minecraft.banner.creeper.magenta": "Ae muse di creeper di magenta",
  "block.minecraft.banner.creeper.orange": "Ae muse di creeper di naranç",
  "block.minecraft.banner.creeper.pink": "Ae muse di creeper di rose",
  "block.minecraft.banner.creeper.purple": "Ae muse di creeper di viole",
  "block.minecraft.banner.creeper.red": "Ae muse di creeper di ros",
  "block.minecraft.banner.creeper.white": "Ae muse di creeper di blanc",
  "block.minecraft.banner.creeper.yellow": "Ae muse di creeper di zâl",
  "block.minecraft.banner.cross.black": "Ae crôs di S. Andree di neri",
  "block.minecraft.banner.cross.blue": "Ae crôs di S. Andree di blu",
  "block.minecraft.banner.cross.brown": "Ae crôs di S. Andree di maron",
  "block.minecraft.banner.cross.cyan": "Ae crôs di S. Andree di ciano",
  "block.minecraft.banner.cross.gray": "Ae crôs di S. Andree di grîs",
  "block.minecraft.banner.cross.green": "Ae crôs di S. Andree di vert",
  "block.minecraft.banner.cross.light_blue": "Ae crôs di S. Andree di blu clâr",
  "block.minecraft.banner.cross.light_gray": "Ae crôs di S. Andree di grîs clâr",
  "block.minecraft.banner.cross.lime": "Ae crôs di S. Andree di vert limon",
  "block.minecraft.banner.cross.magenta": "Ae crôs di S. Andree di magenta",
  "block.minecraft.banner.cross.orange": "Ae crôs di S. Andree di naranç",
  "block.minecraft.banner.cross.pink": "Ae crôs di S. Andree di rose",
  "block.minecraft.banner.cross.purple": "Ae crôs di S. Andree di viole",
  "block.minecraft.banner.cross.red": "Ae crôs di S. Andree di ros",
  "block.minecraft.banner.cross.white": "Ae crôs di S. Andree di blanc",
  "block.minecraft.banner.cross.yellow": "Ae crôs di S. Andree di zâl",
  "block.minecraft.banner.curly_border.black": "Ae bordure dentelade di neri",
  "block.minecraft.banner.curly_border.blue": "Ae bordure dentelade di blu",
  "block.minecraft.banner.curly_border.brown": "Ae bordure dentelade di maron",
  "block.minecraft.banner.curly_border.cyan": "Ae bordure dentelade di ciano",
  "block.minecraft.banner.curly_border.gray": "Ae bordure dentelade di grîs",
  "block.minecraft.banner.curly_border.green": "Ae bordure dentelade di vert",
  "block.minecraft.banner.curly_border.light_blue": "Ae bordure dentelade di blu clâr",
  "block.minecraft.banner.curly_border.light_gray": "Ae bordure dentelade di grîs clâr",
  "block.minecraft.banner.curly_border.lime": "Ae bordure dentelade di vert limon",
  "block.minecraft.banner.curly_border.magenta": "Ae bordure dentelade di magenta",
  "block.minecraft.banner.curly_border.orange": "Ae bordure dentelade di naranç",
  "block.minecraft.banner.curly_border.pink": "Ae bordure dentelade di rose",
  "block.minecraft.banner.curly_border.purple": "Ae bordure dentelade di viole",
  "block.minecraft.banner.curly_border.red": "Ae bordure dentelade di ros",
  "block.minecraft.banner.curly_border.white": "Ae bordure dentelade di blanc",
  "block.minecraft.banner.curly_border.yellow": "Ae bordure dentelade di zâl",
  "block.minecraft.banner.diagonal_left.black": "Taiât: tal 1ⁿ di neri",
  "block.minecraft.banner.diagonal_left.blue": "Taiât: tal 1ⁿ di blu",
  "block.minecraft.banner.diagonal_left.brown": "Taiât: tal 1ⁿ di maron",
  "block.minecraft.banner.diagonal_left.cyan": "Taiât: tal 1ⁿ di ciano",
  "block.minecraft.banner.diagonal_left.gray": "Taiât: tal 1ⁿ di grîs",
  "block.minecraft.banner.diagonal_left.green": "Taiât: tal 1ⁿ di vert",
  "block.minecraft.banner.diagonal_left.light_blue": "Taiât: tal 1ⁿ di blu clâr",
  "block.minecraft.banner.diagonal_left.light_gray": "Taiât: tal 1ⁿ di grîs clâr",
  "block.minecraft.banner.diagonal_left.lime": "Taiât: tal 1ⁿ di vert limon",
  "block.minecraft.banner.diagonal_left.magenta": "Taiât: tal 1ⁿ di magenta",
  "block.minecraft.banner.diagonal_left.orange": "Taiât: tal 1ⁿ di naranç",
  "block.minecraft.banner.diagonal_left.pink": "Taiât: tal 1ⁿ di rose",
  "block.minecraft.banner.diagonal_left.purple": "Taiât: tal 1ⁿ di viole",
  "block.minecraft.banner.diagonal_left.red": "Taiât: tal 1ⁿ di ros",
  "block.minecraft.banner.diagonal_left.white": "Taiât: tal 1ⁿ di blanc",
  "block.minecraft.banner.diagonal_left.yellow": "Taiât: tal 1ⁿ di zâl",
  "block.minecraft.banner.diagonal_right.black": "Trançât: tal 1ⁿ di neri",
  "block.minecraft.banner.diagonal_right.blue": "Trançât: tal 1ⁿ di blu",
  "block.minecraft.banner.diagonal_right.brown": "Trançât: tal 1ⁿ di maron",
  "block.minecraft.banner.diagonal_right.cyan": "Trançât: tal 1ⁿ di ciano",
  "block.minecraft.banner.diagonal_right.gray": "Trançât: tal 1ⁿ di grîs",
  "block.minecraft.banner.diagonal_right.green": "Trançât: tal 1ⁿ di vert",
  "block.minecraft.banner.diagonal_right.light_blue": "Trançât: tal 1ⁿ di blu clâr",
  "block.minecraft.banner.diagonal_right.light_gray": "Trançât: tal 1ⁿ di grîs clâr",
  "block.minecraft.banner.diagonal_right.lime": "Trançât: tal 1ⁿ di vert limon",
  "block.minecraft.banner.diagonal_right.magenta": "Trançât: tal 1ⁿ di magenta",
  "block.minecraft.banner.diagonal_right.orange": "Trançât: tal 1ⁿ di naranç",
  "block.minecraft.banner.diagonal_right.pink": "Trançât: tal 1ⁿ di rose",
  "block.minecraft.banner.diagonal_right.purple": "Trançât: tal 1ⁿ di viole",
  "block.minecraft.banner.diagonal_right.red": "Trançât: tal 1ⁿ di ros",
  "block.minecraft.banner.diagonal_right.white": "Trançât: tal 1ⁿ di blanc",
  "block.minecraft.banner.diagonal_right.yellow": "Trançât: tal 1ⁿ di zâl",
  "block.minecraft.banner.diagonal_up_left.black": "Trançât: tal 2ᵗ di neri",
  "block.minecraft.banner.diagonal_up_left.blue": "Trançât: tal 2ᵗ di blu",
  "block.minecraft.banner.diagonal_up_left.brown": "Trançât: tal 2ᵗ di maron",
  "block.minecraft.banner.diagonal_up_left.cyan": "Trançât: tal 2ᵗ di ciano",
  "block.minecraft.banner.diagonal_up_left.gray": "Trançât: tal 2ᵗ di grîs",
  "block.minecraft.banner.diagonal_up_left.green": "Trançât: tal 2ᵗ di vert",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Trançât: tal 2ᵗ di blu clâr",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Trançât: tal 2ᵗ di grîs clâr",
  "block.minecraft.banner.diagonal_up_left.lime": "Trançât: tal 2ᵗ di vert limon",
  "block.minecraft.banner.diagonal_up_left.magenta": "Trançât: tal 2ᵗ di magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Trançât: tal 2ᵗ di naranç",
  "block.minecraft.banner.diagonal_up_left.pink": "Trançât: tal 2ᵗ di rose",
  "block.minecraft.banner.diagonal_up_left.purple": "Trançât: tal 2ᵗ di viole",
  "block.minecraft.banner.diagonal_up_left.red": "Trançât: tal 2ᵗ di ros",
  "block.minecraft.banner.diagonal_up_left.white": "Trançât: tal 2ᵗ di blanc",
  "block.minecraft.banner.diagonal_up_left.yellow": "Trançât: tal 2ᵗ di zâl",
  "block.minecraft.banner.diagonal_up_right.black": "Taiât: tal 2ᵗ di neri",
  "block.minecraft.banner.diagonal_up_right.blue": "Taiât: tal 2ᵗ di blu",
  "block.minecraft.banner.diagonal_up_right.brown": "Taiât: tal 2ᵗ di maron",
  "block.minecraft.banner.diagonal_up_right.cyan": "Taiât: tal 2ᵗ di ciano",
  "block.minecraft.banner.diagonal_up_right.gray": "Taiât: tal 2ᵗ di grîs",
  "block.minecraft.banner.diagonal_up_right.green": "Taiât: tal 2ᵗ di vert",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Taiât: tal 2ᵗ di blu clâr",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Taiât: tal 2ᵗ di grîs clâr",
  "block.minecraft.banner.diagonal_up_right.lime": "Taiât: tal 2ᵗ di vert limon",
  "block.minecraft.banner.diagonal_up_right.magenta": "Taiât: tal 2ᵗ di magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Taiât: tal 2ᵗ di naranç",
  "block.minecraft.banner.diagonal_up_right.pink": "Taiât: tal 2ᵗ di rose",
  "block.minecraft.banner.diagonal_up_right.purple": "Taiât: tal 2ᵗ di viole",
  "block.minecraft.banner.diagonal_up_right.red": "Taiât: tal 2ᵗ di ros",
  "block.minecraft.banner.diagonal_up_right.white": "Taiât: tal 2ᵗ di blanc",
  "block.minecraft.banner.diagonal_up_right.yellow": "Taiât: tal 2ᵗ di zâl",
  "block.minecraft.banner.flow.black": "Flus neri",
  "block.minecraft.banner.flow.blue": "Flus blu",
  "block.minecraft.banner.flow.brown": "Flus maron",
  "block.minecraft.banner.flow.cyan": "Flus ciano",
  "block.minecraft.banner.flow.gray": "Flus grîs",
  "block.minecraft.banner.flow.green": "Flus vert",
  "block.minecraft.banner.flow.light_blue": "Flus blu clâr",
  "block.minecraft.banner.flow.light_gray": "Flus grîs clâr",
  "block.minecraft.banner.flow.lime": "Flus vert limon",
  "block.minecraft.banner.flow.magenta": "Flus magenta",
  "block.minecraft.banner.flow.orange": "Flus naranç",
  "block.minecraft.banner.flow.pink": "Flus rose",
  "block.minecraft.banner.flow.purple": "Flus viole",
  "block.minecraft.banner.flow.red": "Flus ros",
  "block.minecraft.banner.flow.white": "Flus blanc",
  "block.minecraft.banner.flow.yellow": "Flus zâl",
  "block.minecraft.banner.flower.black": "Ae rose di neri",
  "block.minecraft.banner.flower.blue": "Ae rose di blu",
  "block.minecraft.banner.flower.brown": "Ae rose di maron",
  "block.minecraft.banner.flower.cyan": "Ae rose di ciano",
  "block.minecraft.banner.flower.gray": "Ae rose di grîs",
  "block.minecraft.banner.flower.green": "Ae rose di vert",
  "block.minecraft.banner.flower.light_blue": "Ae rose di blu clâr",
  "block.minecraft.banner.flower.light_gray": "Ae rose di grîs clâr",
  "block.minecraft.banner.flower.lime": "Ae rose di vert limon",
  "block.minecraft.banner.flower.magenta": "Ae rose di magenta",
  "block.minecraft.banner.flower.orange": "Ae rose di naranç",
  "block.minecraft.banner.flower.pink": "Ae rose di rose",
  "block.minecraft.banner.flower.purple": "Ae rose di viole",
  "block.minecraft.banner.flower.red": "Ae rose di ros",
  "block.minecraft.banner.flower.white": "Ae rose di blanc",
  "block.minecraft.banner.flower.yellow": "Ae rose di zâl",
  "block.minecraft.banner.globe.black": "Ae sfere di neri",
  "block.minecraft.banner.globe.blue": "Ae sfere di blu",
  "block.minecraft.banner.globe.brown": "Ae sfere di maron",
  "block.minecraft.banner.globe.cyan": "Ae sfere di ciano",
  "block.minecraft.banner.globe.gray": "Ae sfere di grîs",
  "block.minecraft.banner.globe.green": "Ae sfere di vert",
  "block.minecraft.banner.globe.light_blue": "Ae sfere di blu clâr",
  "block.minecraft.banner.globe.light_gray": "Ae sfere di grîs clâr",
  "block.minecraft.banner.globe.lime": "Ae sfere di vert limon",
  "block.minecraft.banner.globe.magenta": "Ae sfere di magenta",
  "block.minecraft.banner.globe.orange": "Ae sfere di naranç",
  "block.minecraft.banner.globe.pink": "Ae sfere di rose",
  "block.minecraft.banner.globe.purple": "Ae sfere di viole",
  "block.minecraft.banner.globe.red": "Ae sfere di ros",
  "block.minecraft.banner.globe.white": "Ae sfere di blanc",
  "block.minecraft.banner.globe.yellow": "Ae sfere di zâl",
  "block.minecraft.banner.gradient.black": "Sfumât in cjâf di neri",
  "block.minecraft.banner.gradient.blue": "Sfumât in cjâf di blu",
  "block.minecraft.banner.gradient.brown": "Sfumât in cjâf di maron",
  "block.minecraft.banner.gradient.cyan": "Sfumât in cjâf di ciano",
  "block.minecraft.banner.gradient.gray": "Sfumât in cjâf di grîs",
  "block.minecraft.banner.gradient.green": "Sfumât in cjâf di vert",
  "block.minecraft.banner.gradient.light_blue": "Sfumât in cjâf di blu clâr",
  "block.minecraft.banner.gradient.light_gray": "Sfumât in cjâf di grîs clâr",
  "block.minecraft.banner.gradient.lime": "Sfumât in cjâf di vert limon",
  "block.minecraft.banner.gradient.magenta": "Sfumât in cjâf di magenta",
  "block.minecraft.banner.gradient.orange": "Sfumât in cjâf di naranç",
  "block.minecraft.banner.gradient.pink": "Sfumât in cjâf di rose",
  "block.minecraft.banner.gradient.purple": "Sfumât in cjâf di viole",
  "block.minecraft.banner.gradient.red": "Sfumât in cjâf di ros",
  "block.minecraft.banner.gradient.white": "Sfumât in cjâf di blanc",
  "block.minecraft.banner.gradient.yellow": "Sfumât in cjâf di zâl",
  "block.minecraft.banner.gradient_up.black": "Sfumât in ponte di neri",
  "block.minecraft.banner.gradient_up.blue": "Sfumât in ponte di blu",
  "block.minecraft.banner.gradient_up.brown": "Sfumât in ponte di maron",
  "block.minecraft.banner.gradient_up.cyan": "Sfumât in ponte di ciano",
  "block.minecraft.banner.gradient_up.gray": "Sfumât in ponte di grîs",
  "block.minecraft.banner.gradient_up.green": "Sfumât in ponte di vert",
  "block.minecraft.banner.gradient_up.light_blue": "Sfumât in ponte di blu clâr",
  "block.minecraft.banner.gradient_up.light_gray": "Sfumât in ponte di grîs clâr",
  "block.minecraft.banner.gradient_up.lime": "Sfumât in ponte di vert limon",
  "block.minecraft.banner.gradient_up.magenta": "Sfumât in ponte di magenta",
  "block.minecraft.banner.gradient_up.orange": "Sfumât in ponte di naranç",
  "block.minecraft.banner.gradient_up.pink": "Sfumât in ponte di rose",
  "block.minecraft.banner.gradient_up.purple": "Sfumât in ponte di viole",
  "block.minecraft.banner.gradient_up.red": "Sfumât in ponte di ros",
  "block.minecraft.banner.gradient_up.white": "Sfumât in ponte di blanc",
  "block.minecraft.banner.gradient_up.yellow": "Sfumât in ponte di zâl",
  "block.minecraft.banner.guster.black": "Bugade nere",
  "block.minecraft.banner.guster.blue": "Bugade blu",
  "block.minecraft.banner.guster.brown": "Bugade maron",
  "block.minecraft.banner.guster.cyan": "Bugade ciano",
  "block.minecraft.banner.guster.gray": "Bugade grise",
  "block.minecraft.banner.guster.green": "Bugade verde",
  "block.minecraft.banner.guster.light_blue": "Bugade blu clâr",
  "block.minecraft.banner.guster.light_gray": "Bugade grîs clâr",
  "block.minecraft.banner.guster.lime": "Bugade vert limon",
  "block.minecraft.banner.guster.magenta": "Bugade magenta",
  "block.minecraft.banner.guster.orange": "Bugade naranç",
  "block.minecraft.banner.guster.pink": "Bugade rose",
  "block.minecraft.banner.guster.purple": "Bugade viole",
  "block.minecraft.banner.guster.red": "Bugade rosse",
  "block.minecraft.banner.guster.white": "Bugade blancje",
  "block.minecraft.banner.guster.yellow": "Bugade zale",
  "block.minecraft.banner.half_horizontal.black": "Çoncjât: tal 1ⁿ di neri",
  "block.minecraft.banner.half_horizontal.blue": "Çoncjât: tal 1ⁿ di blu",
  "block.minecraft.banner.half_horizontal.brown": "Çoncjât: tal 1ⁿ di maron",
  "block.minecraft.banner.half_horizontal.cyan": "Çoncjât: tal 1ⁿ di ciano",
  "block.minecraft.banner.half_horizontal.gray": "Çoncjât: tal 1ⁿ di grîs",
  "block.minecraft.banner.half_horizontal.green": "Çoncjât: tal 1ⁿ di vert",
  "block.minecraft.banner.half_horizontal.light_blue": "Çoncjât: tal 1ⁿ di blu clâr",
  "block.minecraft.banner.half_horizontal.light_gray": "Çoncjât: tal 1ⁿ di grîs clâr",
  "block.minecraft.banner.half_horizontal.lime": "Çoncjât: tal 1ⁿ di vert limon",
  "block.minecraft.banner.half_horizontal.magenta": "Çoncjât: tal 1ⁿ di magenta",
  "block.minecraft.banner.half_horizontal.orange": "Çoncjât: tal 1ⁿ di naranç",
  "block.minecraft.banner.half_horizontal.pink": "Çoncjât: tal 1ⁿ di rose",
  "block.minecraft.banner.half_horizontal.purple": "Çoncjât: tal 1ⁿ di viole",
  "block.minecraft.banner.half_horizontal.red": "Çoncjât: tal 1ⁿ di ros",
  "block.minecraft.banner.half_horizontal.white": "Çoncjât: tal 1ⁿ di blanc",
  "block.minecraft.banner.half_horizontal.yellow": "Çoncjât: tal 1ⁿ di zâl",
  "block.minecraft.banner.half_horizontal_bottom.black": "Çoncjât: tal 2ᵗ di neri",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Çoncjât: tal 2ᵗ di blu",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Çoncjât: tal 2ᵗ di maron",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Çoncjât: tal 2ᵗ di ciano",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Çoncjât: tal 2ᵗ di grîs",
  "block.minecraft.banner.half_horizontal_bottom.green": "Çoncjât: tal 2ᵗ di vert",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Çoncjât: tal 2ᵗ di blu clâr",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Çoncjât: tal 2ᵗ di grîs clâr",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Çoncjât: tal 2ᵗ di vert limon",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Çoncjât: tal 2ᵗ di magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Çoncjât: tal 2ᵗ di naranç",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Çoncjât: tal 2ᵗ di rose",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Çoncjât: tal 2ᵗ di viole",
  "block.minecraft.banner.half_horizontal_bottom.red": "Çoncjât: tal 2ᵗ di ros",
  "block.minecraft.banner.half_horizontal_bottom.white": "Çoncjât: tal 2ᵗ di blanc",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Çoncjât: tal 2ᵗ di zâl",
  "block.minecraft.banner.half_vertical.black": "Partît: tal 1ⁿ di neri",
  "block.minecraft.banner.half_vertical.blue": "Partît: tal 1ⁿ di blu",
  "block.minecraft.banner.half_vertical.brown": "Partît: tal 1ⁿ di maron",
  "block.minecraft.banner.half_vertical.cyan": "Partît: tal 1ⁿ di ciano",
  "block.minecraft.banner.half_vertical.gray": "Partît: tal 1ⁿ di grîs",
  "block.minecraft.banner.half_vertical.green": "Partît: tal 1ⁿ di vert",
  "block.minecraft.banner.half_vertical.light_blue": "Partît: tal 1ⁿ di blu clâr",
  "block.minecraft.banner.half_vertical.light_gray": "Partît: tal 1ⁿ di grîs clâr",
  "block.minecraft.banner.half_vertical.lime": "Partît: tal 1ⁿ di vert limon",
  "block.minecraft.banner.half_vertical.magenta": "Partît: tal 1ⁿ di magenta",
  "block.minecraft.banner.half_vertical.orange": "Partît: tal 1ⁿ di naranç",
  "block.minecraft.banner.half_vertical.pink": "Partît: tal 1ⁿ di rose",
  "block.minecraft.banner.half_vertical.purple": "Partît: tal 1ⁿ di viole",
  "block.minecraft.banner.half_vertical.red": "Partît: tal 1ⁿ di ros",
  "block.minecraft.banner.half_vertical.white": "Partît: tal 1ⁿ di blanc",
  "block.minecraft.banner.half_vertical.yellow": "Partît: tal 1ⁿ di zâl",
  "block.minecraft.banner.half_vertical_right.black": "Partît: tal 2ᵗ di neri",
  "block.minecraft.banner.half_vertical_right.blue": "Partît: tal 2ᵗ di blu",
  "block.minecraft.banner.half_vertical_right.brown": "Partît: tal 2ᵗ di maron",
  "block.minecraft.banner.half_vertical_right.cyan": "Partît: tal 2ᵗ di ciano",
  "block.minecraft.banner.half_vertical_right.gray": "Partît: tal 2ᵗ di grîs",
  "block.minecraft.banner.half_vertical_right.green": "Partît: tal 2ᵗ di vert",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partît: tal 2ᵗ di blu clâr",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partît: tal 2ᵗ di grîs clâr",
  "block.minecraft.banner.half_vertical_right.lime": "Partît: tal 2ᵗ di vert limon",
  "block.minecraft.banner.half_vertical_right.magenta": "Partît: tal 2ᵗ di magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Partît: tal 2ᵗ di naranç",
  "block.minecraft.banner.half_vertical_right.pink": "Partît: tal 2ᵗ di rose",
  "block.minecraft.banner.half_vertical_right.purple": "Partît: tal 2ᵗ di viole",
  "block.minecraft.banner.half_vertical_right.red": "Partît: tal 2ᵗ di ros",
  "block.minecraft.banner.half_vertical_right.white": "Partît: tal 2ᵗ di blanc",
  "block.minecraft.banner.half_vertical_right.yellow": "Partît: tal 2ᵗ di zâl",
  "block.minecraft.banner.mojang.black": "Al logo di neri",
  "block.minecraft.banner.mojang.blue": "Al logo di blu",
  "block.minecraft.banner.mojang.brown": "Al logo di maron",
  "block.minecraft.banner.mojang.cyan": "Al logo di ciano",
  "block.minecraft.banner.mojang.gray": "Al logo di grîs",
  "block.minecraft.banner.mojang.green": "Al logo di vert",
  "block.minecraft.banner.mojang.light_blue": "Al logo di blu clâr",
  "block.minecraft.banner.mojang.light_gray": "Al logo di grîs clâr",
  "block.minecraft.banner.mojang.lime": "Al logo di vert limon",
  "block.minecraft.banner.mojang.magenta": "Al logo di magenta",
  "block.minecraft.banner.mojang.orange": "Al logo di naranç",
  "block.minecraft.banner.mojang.pink": "Al logo di rose",
  "block.minecraft.banner.mojang.purple": "Al logo di viole",
  "block.minecraft.banner.mojang.red": "Al logo di ros",
  "block.minecraft.banner.mojang.white": "Al logo di blanc",
  "block.minecraft.banner.mojang.yellow": "Al logo di zâl",
  "block.minecraft.banner.piglin.black": "Al music di neri",
  "block.minecraft.banner.piglin.blue": "Al music di blu",
  "block.minecraft.banner.piglin.brown": "Al music di maron",
  "block.minecraft.banner.piglin.cyan": "Al music di ciano",
  "block.minecraft.banner.piglin.gray": "Al music di grîs",
  "block.minecraft.banner.piglin.green": "Al music di vert",
  "block.minecraft.banner.piglin.light_blue": "Al music di blu clâr",
  "block.minecraft.banner.piglin.light_gray": "Al music di grîs clâr",
  "block.minecraft.banner.piglin.lime": "Al music di vert limon",
  "block.minecraft.banner.piglin.magenta": "Al music di magenta",
  "block.minecraft.banner.piglin.orange": "Al music di naranç",
  "block.minecraft.banner.piglin.pink": "Al music di rose",
  "block.minecraft.banner.piglin.purple": "Al music di viole",
  "block.minecraft.banner.piglin.red": "Al music di ros",
  "block.minecraft.banner.piglin.white": "Al music di blanc",
  "block.minecraft.banner.piglin.yellow": "Al music di zâl",
  "block.minecraft.banner.rhombus.black": "Ae losanghe di neri",
  "block.minecraft.banner.rhombus.blue": "Ae losanghe di blu",
  "block.minecraft.banner.rhombus.brown": "Ae losanghe di maron",
  "block.minecraft.banner.rhombus.cyan": "Ae losanghe di ciano",
  "block.minecraft.banner.rhombus.gray": "Ae losanghe di grîs",
  "block.minecraft.banner.rhombus.green": "Ae losanghe di vert",
  "block.minecraft.banner.rhombus.light_blue": "Ae losanghe di blu clâr",
  "block.minecraft.banner.rhombus.light_gray": "Ae losanghe di grîs clâr",
  "block.minecraft.banner.rhombus.lime": "Ae losanghe di vert limon",
  "block.minecraft.banner.rhombus.magenta": "Ae losanghe di magenta",
  "block.minecraft.banner.rhombus.orange": "Ae losanghe di naranç",
  "block.minecraft.banner.rhombus.pink": "Ae losanghe di rose",
  "block.minecraft.banner.rhombus.purple": "Ae losanghe di viole",
  "block.minecraft.banner.rhombus.red": "Ae losanghe di ros",
  "block.minecraft.banner.rhombus.white": "Ae losanghe di blanc",
  "block.minecraft.banner.rhombus.yellow": "Ae losanghe di zâl",
  "block.minecraft.banner.skull.black": "Ae crepe di neri",
  "block.minecraft.banner.skull.blue": "Ae crepe di blu",
  "block.minecraft.banner.skull.brown": "Ae crepe di maron",
  "block.minecraft.banner.skull.cyan": "Ae crepe di ciano",
  "block.minecraft.banner.skull.gray": "Ae crepe di grîs",
  "block.minecraft.banner.skull.green": "Ae crepe di vert",
  "block.minecraft.banner.skull.light_blue": "Ae crepe di blu clâr",
  "block.minecraft.banner.skull.light_gray": "Ae crepe di grîs clâr",
  "block.minecraft.banner.skull.lime": "Ae crepe di vert limon",
  "block.minecraft.banner.skull.magenta": "Ae crepe di magenta",
  "block.minecraft.banner.skull.orange": "Ae crepe di naranç",
  "block.minecraft.banner.skull.pink": "Ae crepe di rose",
  "block.minecraft.banner.skull.purple": "Ae crepe di viole",
  "block.minecraft.banner.skull.red": "Ae crepe di ros",
  "block.minecraft.banner.skull.white": "Ae crepe di blanc",
  "block.minecraft.banner.skull.yellow": "Ae crepe di zâl",
  "block.minecraft.banner.small_stripes.black": "Ai pâi di neri",
  "block.minecraft.banner.small_stripes.blue": "Ai pâi di blu",
  "block.minecraft.banner.small_stripes.brown": "Ai pâi di maron",
  "block.minecraft.banner.small_stripes.cyan": "Ai pâi di ciano",
  "block.minecraft.banner.small_stripes.gray": "Ai pâi di grîs",
  "block.minecraft.banner.small_stripes.green": "Ai pâi di vert",
  "block.minecraft.banner.small_stripes.light_blue": "Ai pâi di blu clâr",
  "block.minecraft.banner.small_stripes.light_gray": "Ai pâi di grîs clâr",
  "block.minecraft.banner.small_stripes.lime": "Ai pâi di vert limon",
  "block.minecraft.banner.small_stripes.magenta": "Ai pâi di magenta",
  "block.minecraft.banner.small_stripes.orange": "Ai pâi di naranç",
  "block.minecraft.banner.small_stripes.pink": "Ai pâi di rose",
  "block.minecraft.banner.small_stripes.purple": "Ai pâi di viole",
  "block.minecraft.banner.small_stripes.red": "Ai pâi di ros",
  "block.minecraft.banner.small_stripes.white": "Ai pâi di blanc",
  "block.minecraft.banner.small_stripes.yellow": "Ai pâi di zâl",
  "block.minecraft.banner.square_bottom_left.black": "Al cjanton diestri de ponte di neri",
  "block.minecraft.banner.square_bottom_left.blue": "Al cjanton diestri de ponte di blu",
  "block.minecraft.banner.square_bottom_left.brown": "Al cjanton diestri de ponte di maron",
  "block.minecraft.banner.square_bottom_left.cyan": "Al cjanton diestri de ponte di ciano",
  "block.minecraft.banner.square_bottom_left.gray": "Al cjanton diestri de ponte di grîs",
  "block.minecraft.banner.square_bottom_left.green": "Al cjanton diestri de ponte di vert",
  "block.minecraft.banner.square_bottom_left.light_blue": "Al cjanton diestri de ponte di blu clâr",
  "block.minecraft.banner.square_bottom_left.light_gray": "Al cjanton diestri de ponte di grîs clâr",
  "block.minecraft.banner.square_bottom_left.lime": "Al cjanton diestri de ponte di vert limon",
  "block.minecraft.banner.square_bottom_left.magenta": "Al cjanton diestri de ponte di magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Al cjanton diestri de ponte di naranç",
  "block.minecraft.banner.square_bottom_left.pink": "Al cjanton diestri de ponte di rose",
  "block.minecraft.banner.square_bottom_left.purple": "Al cjanton diestri de ponte di viole",
  "block.minecraft.banner.square_bottom_left.red": "Al cjanton diestri de ponte di ros",
  "block.minecraft.banner.square_bottom_left.white": "Al cjanton diestri de ponte di blanc",
  "block.minecraft.banner.square_bottom_left.yellow": "Al cjanton diestri de ponte di zâl",
  "block.minecraft.banner.square_bottom_right.black": "Al cjanton di çampe de ponte di neri",
  "block.minecraft.banner.square_bottom_right.blue": "Al cjanton di çampe de ponte di blu",
  "block.minecraft.banner.square_bottom_right.brown": "Al cjanton di çampe de ponte di maron",
  "block.minecraft.banner.square_bottom_right.cyan": "Al cjanton di çampe de ponte di ciano",
  "block.minecraft.banner.square_bottom_right.gray": "Al cjanton di çampe de ponte di grîs",
  "block.minecraft.banner.square_bottom_right.green": "Al cjanton di çampe de ponte di vert",
  "block.minecraft.banner.square_bottom_right.light_blue": "Al cjanton di çampe de ponte di blu clâr",
  "block.minecraft.banner.square_bottom_right.light_gray": "Al cjanton di çampe de ponte di grîs clâr",
  "block.minecraft.banner.square_bottom_right.lime": "Al cjanton di çampe de ponte di vert limon",
  "block.minecraft.banner.square_bottom_right.magenta": "Al cjanton di çampe de ponte di magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Al cjanton di çampe de ponte di naranç",
  "block.minecraft.banner.square_bottom_right.pink": "Al cjanton di çampe de ponte di rose",
  "block.minecraft.banner.square_bottom_right.purple": "Al cjanton di çampe de ponte di viole",
  "block.minecraft.banner.square_bottom_right.red": "Al cjanton di çampe de ponte di ros",
  "block.minecraft.banner.square_bottom_right.white": "Al cjanton di çampe de ponte di blanc",
  "block.minecraft.banner.square_bottom_right.yellow": "Al cjanton di çampe de ponte di zâl",
  "block.minecraft.banner.square_top_left.black": "Al cjanton diestri dal cjâf di neri",
  "block.minecraft.banner.square_top_left.blue": "Al cjanton diestri dal cjâf di blu",
  "block.minecraft.banner.square_top_left.brown": "Al cjanton diestri dal cjâf di maron",
  "block.minecraft.banner.square_top_left.cyan": "Al cjanton diestri dal cjâf di ciano",
  "block.minecraft.banner.square_top_left.gray": "Al cjanton diestri dal cjâf di grîs",
  "block.minecraft.banner.square_top_left.green": "Al cjanton diestri dal cjâf di vert",
  "block.minecraft.banner.square_top_left.light_blue": "Al cjanton diestri dal cjâf di blu clâr",
  "block.minecraft.banner.square_top_left.light_gray": "Al cjanton diestri dal cjâf di grîs clâr",
  "block.minecraft.banner.square_top_left.lime": "Al cjanton diestri dal cjâf di vert limon",
  "block.minecraft.banner.square_top_left.magenta": "Al cjanton diestri dal cjâf di magenta",
  "block.minecraft.banner.square_top_left.orange": "Al cjanton diestri dal cjâf di naranç",
  "block.minecraft.banner.square_top_left.pink": "Al cjanton diestri dal cjâf di rose",
  "block.minecraft.banner.square_top_left.purple": "Al cjanton diestri dal cjâf di viole",
  "block.minecraft.banner.square_top_left.red": "Al cjanton diestri dal cjâf di ros",
  "block.minecraft.banner.square_top_left.white": "Al cjanton diestri dal cjâf di blanc",
  "block.minecraft.banner.square_top_left.yellow": "Al cjanton diestri dal cjâf di zâl",
  "block.minecraft.banner.square_top_right.black": "Al cjanton di çampe dal cjâf di neri",
  "block.minecraft.banner.square_top_right.blue": "Al cjanton di çampe dal cjâf di blu",
  "block.minecraft.banner.square_top_right.brown": "Al cjanton di çampe dal cjâf di maron",
  "block.minecraft.banner.square_top_right.cyan": "Al cjanton di çampe dal cjâf di ciano",
  "block.minecraft.banner.square_top_right.gray": "Al cjanton di çampe dal cjâf di grîs",
  "block.minecraft.banner.square_top_right.green": "Al cjanton di çampe dal cjâf di vert",
  "block.minecraft.banner.square_top_right.light_blue": "Al cjanton di çampe dal cjâf di blu clâr",
  "block.minecraft.banner.square_top_right.light_gray": "Al cjanton di çampe dal cjâf di grîs clâr",
  "block.minecraft.banner.square_top_right.lime": "Al cjanton di çampe dal cjâf di vert limon",
  "block.minecraft.banner.square_top_right.magenta": "Al cjanton di çampe dal cjâf di magenta",
  "block.minecraft.banner.square_top_right.orange": "Al cjanton di çampe dal cjâf di naranç",
  "block.minecraft.banner.square_top_right.pink": "Al cjanton di çampe dal cjâf di rose",
  "block.minecraft.banner.square_top_right.purple": "Al cjanton di çampe dal cjâf di viole",
  "block.minecraft.banner.square_top_right.red": "Al cjanton di çampe dal cjâf di ros",
  "block.minecraft.banner.square_top_right.white": "Al cjanton di çampe dal cjâf di blanc",
  "block.minecraft.banner.square_top_right.yellow": "Al cjanton di çampe dal cjâf di zâl",
  "block.minecraft.banner.straight_cross.black": "Ae crôs di neri",
  "block.minecraft.banner.straight_cross.blue": "Ae crôs di blu",
  "block.minecraft.banner.straight_cross.brown": "Ae crôs di maron",
  "block.minecraft.banner.straight_cross.cyan": "Ae crôs di ciano",
  "block.minecraft.banner.straight_cross.gray": "Ae crôs di grîs",
  "block.minecraft.banner.straight_cross.green": "Ae crôs di vert",
  "block.minecraft.banner.straight_cross.light_blue": "Ae crôs di blu clâr",
  "block.minecraft.banner.straight_cross.light_gray": "Ae crôs di grîs clâr",
  "block.minecraft.banner.straight_cross.lime": "Ae crôs di vert limon",
  "block.minecraft.banner.straight_cross.magenta": "Ae crôs di magenta",
  "block.minecraft.banner.straight_cross.orange": "Ae crôs di naranç",
  "block.minecraft.banner.straight_cross.pink": "Ae crôs di rose",
  "block.minecraft.banner.straight_cross.purple": "Ae crôs di viole",
  "block.minecraft.banner.straight_cross.red": "Ae crôs di ros",
  "block.minecraft.banner.straight_cross.white": "Ae crôs di blanc",
  "block.minecraft.banner.straight_cross.yellow": "Ae crôs di zâl",
  "block.minecraft.banner.stripe_bottom.black": "Ae fasse in ponte di neri",
  "block.minecraft.banner.stripe_bottom.blue": "Ae fasse in ponte di blu",
  "block.minecraft.banner.stripe_bottom.brown": "Ae fasse in ponte di maron",
  "block.minecraft.banner.stripe_bottom.cyan": "Ae fasse in ponte di ciano",
  "block.minecraft.banner.stripe_bottom.gray": "Ae fasse in ponte di grîs",
  "block.minecraft.banner.stripe_bottom.green": "Ae fasse in ponte di vert",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ae fasse in ponte di blu clâr",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ae fasse in ponte di grîs clâr",
  "block.minecraft.banner.stripe_bottom.lime": "Ae fasse in ponte di vert limon",
  "block.minecraft.banner.stripe_bottom.magenta": "Ae fasse in ponte di magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Ae fasse in ponte di naranç",
  "block.minecraft.banner.stripe_bottom.pink": "Ae fasse in ponte di rose",
  "block.minecraft.banner.stripe_bottom.purple": "Ae fasse in ponte di viole",
  "block.minecraft.banner.stripe_bottom.red": "Ae fasse in ponte di ros",
  "block.minecraft.banner.stripe_bottom.white": "Ae fasse in ponte di blanc",
  "block.minecraft.banner.stripe_bottom.yellow": "Ae fasse in ponte di zâl",
  "block.minecraft.banner.stripe_center.black": "Al pâl di neri",
  "block.minecraft.banner.stripe_center.blue": "Al pâl di blu",
  "block.minecraft.banner.stripe_center.brown": "Al pâl di maron",
  "block.minecraft.banner.stripe_center.cyan": "Al pâl di ciano",
  "block.minecraft.banner.stripe_center.gray": "Al pâl di grîs",
  "block.minecraft.banner.stripe_center.green": "Al pâl di vert",
  "block.minecraft.banner.stripe_center.light_blue": "Al pâl di blu clâr",
  "block.minecraft.banner.stripe_center.light_gray": "Al pâl di grîs clâr",
  "block.minecraft.banner.stripe_center.lime": "Al pâl di vert limon",
  "block.minecraft.banner.stripe_center.magenta": "Al pâl di magenta",
  "block.minecraft.banner.stripe_center.orange": "Al pâl di naranç",
  "block.minecraft.banner.stripe_center.pink": "Al pâl di rose",
  "block.minecraft.banner.stripe_center.purple": "Al pâl di viole",
  "block.minecraft.banner.stripe_center.red": "Al pâl di ros",
  "block.minecraft.banner.stripe_center.white": "Al pâl di blanc",
  "block.minecraft.banner.stripe_center.yellow": "Al pâl di zâl",
  "block.minecraft.banner.stripe_downleft.black": "Ae sbare di neri",
  "block.minecraft.banner.stripe_downleft.blue": "Ae sbare di blu",
  "block.minecraft.banner.stripe_downleft.brown": "Ae sbare di maron",
  "block.minecraft.banner.stripe_downleft.cyan": "Ae sbare di ciano",
  "block.minecraft.banner.stripe_downleft.gray": "Ae sbare di grîs",
  "block.minecraft.banner.stripe_downleft.green": "Ae sbare di vert",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ae sbare di blu clâr",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ae sbare di grîs clâr",
  "block.minecraft.banner.stripe_downleft.lime": "Ae sbare di vert limon",
  "block.minecraft.banner.stripe_downleft.magenta": "Ae sbare di magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Ae sbare di naranç",
  "block.minecraft.banner.stripe_downleft.pink": "Ae sbare di rose",
  "block.minecraft.banner.stripe_downleft.purple": "Ae sbare di viole",
  "block.minecraft.banner.stripe_downleft.red": "Ae sbare di ros",
  "block.minecraft.banner.stripe_downleft.white": "Ae sbare di blanc",
  "block.minecraft.banner.stripe_downleft.yellow": "Ae sbare di zâl",
  "block.minecraft.banner.stripe_downright.black": "Ae bande di neri",
  "block.minecraft.banner.stripe_downright.blue": "Ae bande di blu",
  "block.minecraft.banner.stripe_downright.brown": "Ae bande di maron",
  "block.minecraft.banner.stripe_downright.cyan": "Ae bande di ciano",
  "block.minecraft.banner.stripe_downright.gray": "Ae bande di grîs",
  "block.minecraft.banner.stripe_downright.green": "Ae bande di vert",
  "block.minecraft.banner.stripe_downright.light_blue": "Ae bande di blu clâr",
  "block.minecraft.banner.stripe_downright.light_gray": "Ae bande di grîs clâr",
  "block.minecraft.banner.stripe_downright.lime": "Ae bande di vert limon",
  "block.minecraft.banner.stripe_downright.magenta": "Ae bande di magenta",
  "block.minecraft.banner.stripe_downright.orange": "Ae bande di naranç",
  "block.minecraft.banner.stripe_downright.pink": "Ae bande di rose",
  "block.minecraft.banner.stripe_downright.purple": "Ae bande di viole",
  "block.minecraft.banner.stripe_downright.red": "Ae bande di ros",
  "block.minecraft.banner.stripe_downright.white": "Ae bande di blanc",
  "block.minecraft.banner.stripe_downright.yellow": "Ae bande di zâl",
  "block.minecraft.banner.stripe_left.black": "Al pâl diestri di neri",
  "block.minecraft.banner.stripe_left.blue": "Al pâl diestri di blu",
  "block.minecraft.banner.stripe_left.brown": "Al pâl diestri di maron",
  "block.minecraft.banner.stripe_left.cyan": "Al pâl diestri di ciano",
  "block.minecraft.banner.stripe_left.gray": "Al pâl diestri di grîs",
  "block.minecraft.banner.stripe_left.green": "Al pâl diestri di vert",
  "block.minecraft.banner.stripe_left.light_blue": "Al pâl diestri di blu clâr",
  "block.minecraft.banner.stripe_left.light_gray": "Al pâl diestri di grîs clâr",
  "block.minecraft.banner.stripe_left.lime": "Al pâl diestri di vert limon",
  "block.minecraft.banner.stripe_left.magenta": "Al pâl diestri di magenta",
  "block.minecraft.banner.stripe_left.orange": "Al pâl diestri di naranç",
  "block.minecraft.banner.stripe_left.pink": "Al pâl diestri di rose",
  "block.minecraft.banner.stripe_left.purple": "Al pâl diestri di viole",
  "block.minecraft.banner.stripe_left.red": "Al pâl diestri di ros",
  "block.minecraft.banner.stripe_left.white": "Al pâl diestri di blanc",
  "block.minecraft.banner.stripe_left.yellow": "Al pâl diestri di zâl",
  "block.minecraft.banner.stripe_middle.black": "Ae fasse di neri",
  "block.minecraft.banner.stripe_middle.blue": "Ae fasse di blu",
  "block.minecraft.banner.stripe_middle.brown": "Ae fasse di maron",
  "block.minecraft.banner.stripe_middle.cyan": "Ae fasse di ciano",
  "block.minecraft.banner.stripe_middle.gray": "Ae fasse di grîs",
  "block.minecraft.banner.stripe_middle.green": "Ae fasse di vert",
  "block.minecraft.banner.stripe_middle.light_blue": "Ae fasse di blu clâr",
  "block.minecraft.banner.stripe_middle.light_gray": "Ae fasse di grîs clâr",
  "block.minecraft.banner.stripe_middle.lime": "Ae fasse di vert limon",
  "block.minecraft.banner.stripe_middle.magenta": "Ae fasse di magenta",
  "block.minecraft.banner.stripe_middle.orange": "Ae fasse di naranç",
  "block.minecraft.banner.stripe_middle.pink": "Ae fasse di rose",
  "block.minecraft.banner.stripe_middle.purple": "Ae fasse di viole",
  "block.minecraft.banner.stripe_middle.red": "Ae fasse di ros",
  "block.minecraft.banner.stripe_middle.white": "Ae fasse di blanc",
  "block.minecraft.banner.stripe_middle.yellow": "Ae fasse di zâl",
  "block.minecraft.banner.stripe_right.black": "Al pâl di çampe di neri",
  "block.minecraft.banner.stripe_right.blue": "Al pâl di çampe di blu",
  "block.minecraft.banner.stripe_right.brown": "Al pâl di çampe di maron",
  "block.minecraft.banner.stripe_right.cyan": "Al pâl di çampe di ciano",
  "block.minecraft.banner.stripe_right.gray": "Al pâl di çampe di grîs",
  "block.minecraft.banner.stripe_right.green": "Al pâl di çampe di vert",
  "block.minecraft.banner.stripe_right.light_blue": "Al pâl di çampe di blu clâr",
  "block.minecraft.banner.stripe_right.light_gray": "Al pâl di çampe di grîs clâr",
  "block.minecraft.banner.stripe_right.lime": "Al pâl di çampe di vert limon",
  "block.minecraft.banner.stripe_right.magenta": "Al pâl di çampe di magenta",
  "block.minecraft.banner.stripe_right.orange": "Al pâl di çampe di naranç",
  "block.minecraft.banner.stripe_right.pink": "Al pâl di çampe di rose",
  "block.minecraft.banner.stripe_right.purple": "Al pâl di çampe di viole",
  "block.minecraft.banner.stripe_right.red": "Al pâl di çampe di ros",
  "block.minecraft.banner.stripe_right.white": "Al pâl di çampe di blanc",
  "block.minecraft.banner.stripe_right.yellow": "Al pâl di çampe di zâl",
  "block.minecraft.banner.stripe_top.black": "Ae fasse in cjâf di neri",
  "block.minecraft.banner.stripe_top.blue": "Ae fasse in cjâf di blu",
  "block.minecraft.banner.stripe_top.brown": "Ae fasse in cjâf di maron",
  "block.minecraft.banner.stripe_top.cyan": "Ae fasse in cjâf di ciano",
  "block.minecraft.banner.stripe_top.gray": "Ae fasse in cjâf di grîs",
  "block.minecraft.banner.stripe_top.green": "Ae fasse in cjâf di vert",
  "block.minecraft.banner.stripe_top.light_blue": "Ae fasse in cjâf di blu clâr",
  "block.minecraft.banner.stripe_top.light_gray": "Ae fasse in cjâf di grîs clâr",
  "block.minecraft.banner.stripe_top.lime": "Ae fasse in cjâf di vert limon",
  "block.minecraft.banner.stripe_top.magenta": "Ae fasse in cjâf di magenta",
  "block.minecraft.banner.stripe_top.orange": "Ae fasse in cjâf di naranç",
  "block.minecraft.banner.stripe_top.pink": "Ae fasse in cjâf di rose",
  "block.minecraft.banner.stripe_top.purple": "Ae fasse in cjâf di viole",
  "block.minecraft.banner.stripe_top.red": "Ae fasse in cjâf di ros",
  "block.minecraft.banner.stripe_top.white": "Ae fasse in cjâf di blanc",
  "block.minecraft.banner.stripe_top.yellow": "Ae fasse in cjâf di zâl",
  "block.minecraft.banner.triangle_bottom.black": "Ae ponte di neri",
  "block.minecraft.banner.triangle_bottom.blue": "Ae ponte di blu",
  "block.minecraft.banner.triangle_bottom.brown": "Ae ponte di maron",
  "block.minecraft.banner.triangle_bottom.cyan": "Ae ponte di ciano",
  "block.minecraft.banner.triangle_bottom.gray": "Ae ponte di grîs",
  "block.minecraft.banner.triangle_bottom.green": "Ae ponte di vert",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ae ponte di blu clâr",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ae ponte di grîs clâr",
  "block.minecraft.banner.triangle_bottom.lime": "Ae ponte di vert limon",
  "block.minecraft.banner.triangle_bottom.magenta": "Ae ponte di magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Ae ponte di naranç",
  "block.minecraft.banner.triangle_bottom.pink": "Ae ponte di rose",
  "block.minecraft.banner.triangle_bottom.purple": "Ae ponte di viole",
  "block.minecraft.banner.triangle_bottom.red": "Ae ponte di ros",
  "block.minecraft.banner.triangle_bottom.white": "Ae ponte di blanc",
  "block.minecraft.banner.triangle_bottom.yellow": "Ae ponte di zâl",
  "block.minecraft.banner.triangle_top.black": "Ae ponte ribaltade di neri",
  "block.minecraft.banner.triangle_top.blue": "Ae ponte ribaltade di blu",
  "block.minecraft.banner.triangle_top.brown": "Ae ponte ribaltade di maron",
  "block.minecraft.banner.triangle_top.cyan": "Ae ponte ribaltade di ciano",
  "block.minecraft.banner.triangle_top.gray": "Ae ponte ribaltade di grîs",
  "block.minecraft.banner.triangle_top.green": "Ae ponte ribaltade di vert",
  "block.minecraft.banner.triangle_top.light_blue": "Ae ponte ribaltade di blu clâr",
  "block.minecraft.banner.triangle_top.light_gray": "Ae ponte ribaltade di grîs clâr",
  "block.minecraft.banner.triangle_top.lime": "Ae ponte ribaltade di vert limon",
  "block.minecraft.banner.triangle_top.magenta": "Ae ponte ribaltade di magenta",
  "block.minecraft.banner.triangle_top.orange": "Ae ponte ribaltade di naranç",
  "block.minecraft.banner.triangle_top.pink": "Ae ponte ribaltade di rose",
  "block.minecraft.banner.triangle_top.purple": "Ae ponte ribaltade di viole",
  "block.minecraft.banner.triangle_top.red": "Ae ponte ribaltade di ros",
  "block.minecraft.banner.triangle_top.white": "Ae ponte ribaltade di blanc",
  "block.minecraft.banner.triangle_top.yellow": "Ae ponte ribaltade di zâl",
  "block.minecraft.banner.triangles_bottom.black": "Ae ponte dentelade di neri",
  "block.minecraft.banner.triangles_bottom.blue": "Ae ponte dentelade di blu",
  "block.minecraft.banner.triangles_bottom.brown": "Ae ponte dentelade di maron",
  "block.minecraft.banner.triangles_bottom.cyan": "Ae ponte dentelade di ciano",
  "block.minecraft.banner.triangles_bottom.gray": "Ae ponte dentelade di grîs",
  "block.minecraft.banner.triangles_bottom.green": "Ae ponte dentelade di vert",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ae ponte dentelade di blu clâr",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ae ponte dentelade di grîs clâr",
  "block.minecraft.banner.triangles_bottom.lime": "Ae ponte dentelade di vert limon",
  "block.minecraft.banner.triangles_bottom.magenta": "Ae ponte dentelade di magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Ae ponte dentelade di naranç",
  "block.minecraft.banner.triangles_bottom.pink": "Ae ponte dentelade di rose",
  "block.minecraft.banner.triangles_bottom.purple": "Ae ponte dentelade di viole",
  "block.minecraft.banner.triangles_bottom.red": "Ae ponte dentelade di ros",
  "block.minecraft.banner.triangles_bottom.white": "Ae ponte dentelade di blanc",
  "block.minecraft.banner.triangles_bottom.yellow": "Ae ponte dentelade di zâl",
  "block.minecraft.banner.triangles_top.black": "Al cjâf dentelât di neri",
  "block.minecraft.banner.triangles_top.blue": "Al cjâf dentelât di blu",
  "block.minecraft.banner.triangles_top.brown": "Al cjâf dentelât di maron",
  "block.minecraft.banner.triangles_top.cyan": "Al cjâf dentelât di ciano",
  "block.minecraft.banner.triangles_top.gray": "Al cjâf dentelât di grîs",
  "block.minecraft.banner.triangles_top.green": "Al cjâf dentelât di vert",
  "block.minecraft.banner.triangles_top.light_blue": "Al cjâf dentelât di blu clâr",
  "block.minecraft.banner.triangles_top.light_gray": "Al cjâf dentelât di grîs clâr",
  "block.minecraft.banner.triangles_top.lime": "Al cjâf dentelât di vert limon",
  "block.minecraft.banner.triangles_top.magenta": "Al cjâf dentelât di magenta",
  "block.minecraft.banner.triangles_top.orange": "Al cjâf dentelât di naranç",
  "block.minecraft.banner.triangles_top.pink": "Al cjâf dentelât di rose",
  "block.minecraft.banner.triangles_top.purple": "Al cjâf dentelât di viole",
  "block.minecraft.banner.triangles_top.red": "Al cjâf dentelât di ros",
  "block.minecraft.banner.triangles_top.white": "Al cjâf dentelât di blanc",
  "block.minecraft.banner.triangles_top.yellow": "Al cjâf dentelât di zâl",
  "block.minecraft.barrel": "Caratel",
  "block.minecraft.barrier": "Bariere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Fâr",
  "block.minecraft.beacon.primary": "Podê primari",
  "block.minecraft.beacon.secondary": "Podê secondari",
  "block.minecraft.bed.no_sleep": "Tu puedis durmî dome di gnot o intant dai temporâi",
  "block.minecraft.bed.not_safe": "No tu puedis polsâ cumò, cui mostris dongje",
  "block.minecraft.bed.obstructed": "Chest jet al è ostruît",
  "block.minecraft.bed.occupied": "Chest jet al è ocupât",
  "block.minecraft.bed.too_far_away": "No tu puedis polsâ cumò, il jet al è masse lontan",
  "block.minecraft.bedrock": "Cret di fonts",
  "block.minecraft.bee_nest": "Bôç",
  "block.minecraft.beehive": "Bôç artificiâl",
  "block.minecraft.beetroots": "Jerbe rave",
  "block.minecraft.bell": "Cjampane",
  "block.minecraft.big_dripleaf": "Planteforme grande",
  "block.minecraft.big_dripleaf_stem": "Stoc di planteforme grande",
  "block.minecraft.birch_button": "Boton di bedoi",
  "block.minecraft.birch_door": "Puarte di bedoi",
  "block.minecraft.birch_fence": "Stangjaçade di bedoi",
  "block.minecraft.birch_fence_gate": "Portonut di bedoi",
  "block.minecraft.birch_hanging_sign": "Insegne di bedoi",
  "block.minecraft.birch_leaves": "Fueis di bedoi",
  "block.minecraft.birch_log": "Tronc di bedoi",
  "block.minecraft.birch_planks": "Breis di bedoi",
  "block.minecraft.birch_pressure_plate": "Plache di pression di bedoi",
  "block.minecraft.birch_sapling": "Arbossit di bedoi",
  "block.minecraft.birch_shelf": "Scansie di bedoi",
  "block.minecraft.birch_sign": "Cartel di bedoi",
  "block.minecraft.birch_slab": "Lastre di bedoi",
  "block.minecraft.birch_stairs": "Scjalins di bedoi",
  "block.minecraft.birch_trapdoor": "Trabuchel di bedoi",
  "block.minecraft.birch_wall_hanging_sign": "Insegne di parêt di bedoi",
  "block.minecraft.birch_wall_sign": "Targhe di parêt di bedoi",
  "block.minecraft.birch_wood": "Len di bedoi",
  "block.minecraft.black_banner": "Stendart neri",
  "block.minecraft.black_bed": "Jet neri",
  "block.minecraft.black_candle": "Cjandele nere",
  "block.minecraft.black_candle_cake": "Torte cun cjandele nere",
  "block.minecraft.black_carpet": "Tapêt neri",
  "block.minecraft.black_concrete": "Beton neri",
  "block.minecraft.black_concrete_powder": "Beton neri in polvar",
  "block.minecraft.black_glazed_terracotta": "Crep dât di smalt neri",
  "block.minecraft.black_shulker_box": "Scjatule di shulker nere",
  "block.minecraft.black_stained_glass": "Veri colorât di neri",
  "block.minecraft.black_stained_glass_pane": "Panel di veri colôr neri",
  "block.minecraft.black_terracotta": "Crep neri",
  "block.minecraft.black_wool": "Lane nere",
  "block.minecraft.blackstone": "Pierenere",
  "block.minecraft.blackstone_slab": "Lastre di pierenere",
  "block.minecraft.blackstone_stairs": "Scjalins di pierenere",
  "block.minecraft.blackstone_wall": "Muret di pierenere",
  "block.minecraft.blast_furnace": "For a fusion",
  "block.minecraft.blue_banner": "Stendart blu",
  "block.minecraft.blue_bed": "Jet blu",
  "block.minecraft.blue_candle": "Cjandele blu",
  "block.minecraft.blue_candle_cake": "Torte cun cjandele blu",
  "block.minecraft.blue_carpet": "Tapêt blu",
  "block.minecraft.blue_concrete": "Beton blu",
  "block.minecraft.blue_concrete_powder": "Beton blu in polvar",
  "block.minecraft.blue_glazed_terracotta": "Crep dât di smalt blu",
  "block.minecraft.blue_ice": "Glaç blu",
  "block.minecraft.blue_orchid": "Orchidee blu",
  "block.minecraft.blue_shulker_box": "Scjatule di shulker blu",
  "block.minecraft.blue_stained_glass": "Veri colorât di blu",
  "block.minecraft.blue_stained_glass_pane": "Panel di veri colôr blu",
  "block.minecraft.blue_terracotta": "Crep blu",
  "block.minecraft.blue_wool": "Lane blu",
  "block.minecraft.bone_block": "Bloc di vues",
  "block.minecraft.bookshelf": "Librarie",
  "block.minecraft.brain_coral": "Coral dai cerviei",
  "block.minecraft.brain_coral_block": "Bloc di coral dai cerviei",
  "block.minecraft.brain_coral_fan": "Gorgonie dal coral dai cerviei",
  "block.minecraft.brain_coral_wall_fan": "Gorgonie su mûr dal coral dai cerviei",
  "block.minecraft.brewing_stand": "Lambic",
  "block.minecraft.brick_slab": "Lastre di modons",
  "block.minecraft.brick_stairs": "Scjalins di modons",
  "block.minecraft.brick_wall": "Muret di modons",
  "block.minecraft.bricks": "Modons",
  "block.minecraft.brown_banner": "Stendart maron",
  "block.minecraft.brown_bed": "Jet maron",
  "block.minecraft.brown_candle": "Cjandele maron",
  "block.minecraft.brown_candle_cake": "Torte cun cjandele maron",
  "block.minecraft.brown_carpet": "Tapêt maron",
  "block.minecraft.brown_concrete": "Beton maron",
  "block.minecraft.brown_concrete_powder": "Beton maron in polvar",
  "block.minecraft.brown_glazed_terracotta": "Crep dât di smalt maron",
  "block.minecraft.brown_mushroom": "Fonc maron",
  "block.minecraft.brown_mushroom_block": "Bloc di fonc maron",
  "block.minecraft.brown_shulker_box": "Scjatule di shulker maron",
  "block.minecraft.brown_stained_glass": "Veri colorât di maron",
  "block.minecraft.brown_stained_glass_pane": "Panel di veri colôr maron",
  "block.minecraft.brown_terracotta": "Crep maron",
  "block.minecraft.brown_wool": "Lane maron",
  "block.minecraft.bubble_column": "Colone di bufulis",
  "block.minecraft.bubble_coral": "Coral des bufulis",
  "block.minecraft.bubble_coral_block": "Bloc di coral des bufulis",
  "block.minecraft.bubble_coral_fan": "Gorgonie dal coral des bufulis",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonie su mûr dal coral des bufulis",
  "block.minecraft.budding_amethyst": "Ametiste ingjemant",
  "block.minecraft.bush": "Baraç",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Rose di cactus",
  "block.minecraft.cake": "Torte",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Sensôr di Sculk calibrât",
  "block.minecraft.campfire": "Fogaron",
  "block.minecraft.candle": "Cjandele",
  "block.minecraft.candle_cake": "Torte cun cjandele",
  "block.minecraft.carrots": "Carotis",
  "block.minecraft.cartography_table": "Banc dal cartograf",
  "block.minecraft.carved_pumpkin": "Coce intaiade",
  "block.minecraft.cauldron": "Cjalderon",
  "block.minecraft.cave_air": "Aiar di landri",
  "block.minecraft.cave_vines": "Rimpighins dai landris",
  "block.minecraft.cave_vines_plant": "Plante di rimpighins dai landris",
  "block.minecraft.chain": "Cjadene",
  "block.minecraft.chain_command_block": "Bloc comants concatenâts",
  "block.minecraft.cherry_button": "Boton di cjariesâr",
  "block.minecraft.cherry_door": "Puarte di cjariesâr",
  "block.minecraft.cherry_fence": "Stangjaçade di cjariesâr",
  "block.minecraft.cherry_fence_gate": "Portonut di cjariesâr",
  "block.minecraft.cherry_hanging_sign": "Insegne di cjariesâr",
  "block.minecraft.cherry_leaves": "Fueis di cjariesâr",
  "block.minecraft.cherry_log": "Tronc di cjariesâr",
  "block.minecraft.cherry_planks": "Breis di cjariesâr",
  "block.minecraft.cherry_pressure_plate": "Plache di pression di cjariesâr",
  "block.minecraft.cherry_sapling": "Arbossit di cjariesâr",
  "block.minecraft.cherry_shelf": "Scansie di cjariesâr",
  "block.minecraft.cherry_sign": "Cartel di cjariesâr",
  "block.minecraft.cherry_slab": "Lastre di cjariesâr",
  "block.minecraft.cherry_stairs": "Scjalins di cjariesâr",
  "block.minecraft.cherry_trapdoor": "Trabuchel di cjariesâr",
  "block.minecraft.cherry_wall_hanging_sign": "Insegne di parêt di cjariesâr",
  "block.minecraft.cherry_wall_sign": "Targhe di parêt di cjariesâr",
  "block.minecraft.cherry_wood": "Len di cjariesâr",
  "block.minecraft.chest": "Baûl",
  "block.minecraft.chipped_anvil": "Incuin sclesât",
  "block.minecraft.chiseled_bookshelf": "Librarie ceselade",
  "block.minecraft.chiseled_copper": "Ram ceselât",
  "block.minecraft.chiseled_deepslate": "Ardesie profonde ceselade",
  "block.minecraft.chiseled_nether_bricks": "Modons dal Nether ceselâts",
  "block.minecraft.chiseled_polished_blackstone": "Pierenere lustrade ceselade",
  "block.minecraft.chiseled_quartz_block": "Bloc di cuarç ceselât",
  "block.minecraft.chiseled_red_sandstone": "Arenarie rosse ceselade",
  "block.minecraft.chiseled_resin_bricks": "Modons di resine ceselâts",
  "block.minecraft.chiseled_sandstone": "Arenarie ceselade",
  "block.minecraft.chiseled_stone_bricks": "Modons di piere ceselâts",
  "block.minecraft.chiseled_tuff": "Tof ceselât",
  "block.minecraft.chiseled_tuff_bricks": "Modons di tof ceselâts",
  "block.minecraft.chorus_flower": "Rose corâl",
  "block.minecraft.chorus_plant": "Plante corâl",
  "block.minecraft.clay": "Arzile",
  "block.minecraft.closed_eyeblossom": "Rose-voli sierade",
  "block.minecraft.coal_block": "Bloc di cjarbon",
  "block.minecraft.coal_ore": "Minerâl di cjarbon",
  "block.minecraft.coarse_dirt": "Tiere grese",
  "block.minecraft.cobbled_deepslate": "Claps di ardesie profonde",
  "block.minecraft.cobbled_deepslate_slab": "Lastre di claps di ardesie profonde",
  "block.minecraft.cobbled_deepslate_stairs": "Scjalins di claps di ardesie profonde",
  "block.minecraft.cobbled_deepslate_wall": "Muret di claps di ardesie profonde",
  "block.minecraft.cobblestone": "Claps",
  "block.minecraft.cobblestone_slab": "Lastre di claps",
  "block.minecraft.cobblestone_stairs": "Scjalins di claps",
  "block.minecraft.cobblestone_wall": "Muret di claps",
  "block.minecraft.cobweb": "Tele di ragn",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloc comants",
  "block.minecraft.comparator": "Comparadôr di redstone",
  "block.minecraft.composter": "Compostiere",
  "block.minecraft.conduit": "Condot",
  "block.minecraft.copper_bars": "Sbaris di ram",
  "block.minecraft.copper_block": "Bloc di ram",
  "block.minecraft.copper_bulb": "Lampade di ram",
  "block.minecraft.copper_chain": "Cjadene di ram",
  "block.minecraft.copper_chest": "Baûl di ram",
  "block.minecraft.copper_door": "Puarte di ram",
  "block.minecraft.copper_golem_statue": "Statue di golem di ram",
  "block.minecraft.copper_grate": "Grade di ram",
  "block.minecraft.copper_lantern": "Ferâl di ram",
  "block.minecraft.copper_ore": "Minerâl di ram",
  "block.minecraft.copper_torch": "Torce di ram",
  "block.minecraft.copper_trapdoor": "Trabuchel di ram",
  "block.minecraft.copper_wall_torch": "Torce di ram di parêt",
  "block.minecraft.cornflower": "Barburice",
  "block.minecraft.cracked_deepslate_bricks": "Modons di ardesie profonde crepâts",
  "block.minecraft.cracked_deepslate_tiles": "Piastrelis di ardesie profonde crepadis",
  "block.minecraft.cracked_nether_bricks": "Modons dal Nether crepâts",
  "block.minecraft.cracked_polished_blackstone_bricks": "Modons di pierenere lustrade crepade",
  "block.minecraft.cracked_stone_bricks": "Modons di piere crepâts",
  "block.minecraft.crafter": "Fabricadôr",
  "block.minecraft.crafting_table": "Banc di lavôr",
  "block.minecraft.creaking_heart": "Cûr dal cric",
  "block.minecraft.creeper_head": "Cjâf di creeper",
  "block.minecraft.creeper_wall_head": "Cjâf di creeper a mûr",
  "block.minecraft.crimson_button": "Boton cremisin",
  "block.minecraft.crimson_door": "Puarte cremisine",
  "block.minecraft.crimson_fence": "Stangjaçade cremisine",
  "block.minecraft.crimson_fence_gate": "Portonut cremisin",
  "block.minecraft.crimson_fungus": "Fonc cremisin",
  "block.minecraft.crimson_hanging_sign": "Insegne cremisine",
  "block.minecraft.crimson_hyphae": "Ifis cremisinis",
  "block.minecraft.crimson_nylium": "Neceli cremisin",
  "block.minecraft.crimson_planks": "Breis cremisinis",
  "block.minecraft.crimson_pressure_plate": "Plache di pression cremisine",
  "block.minecraft.crimson_roots": "Lidrîs crimisinis",
  "block.minecraft.crimson_shelf": "Scansie cremisine",
  "block.minecraft.crimson_sign": "Cartel cremisin",
  "block.minecraft.crimson_slab": "Lastre cremisine",
  "block.minecraft.crimson_stairs": "Scjalins cremisins",
  "block.minecraft.crimson_stem": "Tronc cremisin",
  "block.minecraft.crimson_trapdoor": "Trabuchel cremisin",
  "block.minecraft.crimson_wall_hanging_sign": "Insegne di parêt cremisine",
  "block.minecraft.crimson_wall_sign": "Targhe di parêt cremisine",
  "block.minecraft.crying_obsidian": "Ossidiane vaiulinte",
  "block.minecraft.cut_copper": "Ram intaiât",
  "block.minecraft.cut_copper_slab": "Lastre di ram intaiât",
  "block.minecraft.cut_copper_stairs": "Scjalins di ram intaiât",
  "block.minecraft.cut_red_sandstone": "Arenarie rosse intaiade",
  "block.minecraft.cut_red_sandstone_slab": "Lastre di arenarie rosse intaiade",
  "block.minecraft.cut_sandstone": "Arenarie intaiade",
  "block.minecraft.cut_sandstone_slab": "Lastre di arenarie intaiade",
  "block.minecraft.cyan_banner": "Stendart ciano",
  "block.minecraft.cyan_bed": "Jet ciano",
  "block.minecraft.cyan_candle": "Cjandele ciano",
  "block.minecraft.cyan_candle_cake": "Torte cun cjandele ciano",
  "block.minecraft.cyan_carpet": "Tapêt ciano",
  "block.minecraft.cyan_concrete": "Beton ciano",
  "block.minecraft.cyan_concrete_powder": "Beton ciano in polvar",
  "block.minecraft.cyan_glazed_terracotta": "Crep dât di smalt ciano",
  "block.minecraft.cyan_shulker_box": "Scjatule di shulker ciano",
  "block.minecraft.cyan_stained_glass": "Veri colorât di ciano",
  "block.minecraft.cyan_stained_glass_pane": "Panel di veri colôr ciano",
  "block.minecraft.cyan_terracotta": "Crep ciano",
  "block.minecraft.cyan_wool": "Lane ciano",
  "block.minecraft.damaged_anvil": "Incuin ruvinât",
  "block.minecraft.dandelion": "Tale",
  "block.minecraft.dark_oak_button": "Boton di rôl scûr",
  "block.minecraft.dark_oak_door": "Puarte di rôl scûr",
  "block.minecraft.dark_oak_fence": "Stangjaçade di rôl scûr",
  "block.minecraft.dark_oak_fence_gate": "Portonut di rôl scûr",
  "block.minecraft.dark_oak_hanging_sign": "Insegne di rôl scûr",
  "block.minecraft.dark_oak_leaves": "Fueis di rôl scûr",
  "block.minecraft.dark_oak_log": "Tronc di rôl scûr",
  "block.minecraft.dark_oak_planks": "Breis di rôl scûr",
  "block.minecraft.dark_oak_pressure_plate": "Plache di pression di rôl scûr",
  "block.minecraft.dark_oak_sapling": "Arbossit di rôl scûr",
  "block.minecraft.dark_oak_shelf": "Scansie di rôl scûr",
  "block.minecraft.dark_oak_sign": "Cartel di rôl scûr",
  "block.minecraft.dark_oak_slab": "Lastre di rôl scûr",
  "block.minecraft.dark_oak_stairs": "Scjalins di rôl scûr",
  "block.minecraft.dark_oak_trapdoor": "Trabuchel di rôl scûr",
  "block.minecraft.dark_oak_wall_hanging_sign": "Insegne di parêt di rôl scûr",
  "block.minecraft.dark_oak_wall_sign": "Targhe di parêt di rôl scûr",
  "block.minecraft.dark_oak_wood": "Len di rôl scûr",
  "block.minecraft.dark_prismarine": "Prismarine scure",
  "block.minecraft.dark_prismarine_slab": "Lastre di prismarine scure",
  "block.minecraft.dark_prismarine_stairs": "Scjalins di prismarine scure",
  "block.minecraft.daylight_detector": "Rilevadôr lûs diurne",
  "block.minecraft.dead_brain_coral": "Coral dai cerviei muart",
  "block.minecraft.dead_brain_coral_block": "Bloc di coral dai cerviei muart",
  "block.minecraft.dead_brain_coral_fan": "Gorgonie dal coral dai cerviei muart",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonie su mûr dal coral dai cerviei muart",
  "block.minecraft.dead_bubble_coral": "Coral des bufulis muart",
  "block.minecraft.dead_bubble_coral_block": "Bloc di coral des bufulis muart",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonie dal coral des bufulis muart",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonie su mûr dal coral des bufulis muart",
  "block.minecraft.dead_bush": "Sterp sec",
  "block.minecraft.dead_fire_coral": "Coral des flamis muart",
  "block.minecraft.dead_fire_coral_block": "Bloc di coral des flamis muart",
  "block.minecraft.dead_fire_coral_fan": "Gorgonie dal coral des flamis muart",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonie su mûr dal coral des flamis muart",
  "block.minecraft.dead_horn_coral": "Coral dai cuars muart",
  "block.minecraft.dead_horn_coral_block": "Bloc di coral dai cuars muart",
  "block.minecraft.dead_horn_coral_fan": "Gorgonie dal coral dai cuars muart",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonie su mûr dal coral dai cuars muart",
  "block.minecraft.dead_tube_coral": "Coral dai tubui muart",
  "block.minecraft.dead_tube_coral_block": "Bloc di coral dai tubui muart",
  "block.minecraft.dead_tube_coral_fan": "Gorgonie dal coral dai tubui muart",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonie su mûr dal coral dai tubui muart",
  "block.minecraft.decorated_pot": "Vâs decorât",
  "block.minecraft.deepslate": "Ardesie profonde",
  "block.minecraft.deepslate_brick_slab": "Lastre di modons di ardesie profonde",
  "block.minecraft.deepslate_brick_stairs": "Scjalins di modons di ardesie profonde",
  "block.minecraft.deepslate_brick_wall": "Muret di modons di ardesie profonde",
  "block.minecraft.deepslate_bricks": "Modons di ardesie profonde",
  "block.minecraft.deepslate_coal_ore": "Minerâl di cjarbon in ardesie profonde",
  "block.minecraft.deepslate_copper_ore": "Minerâl di ram in ardesie profonde",
  "block.minecraft.deepslate_diamond_ore": "Minerâl di diamant in ardesie profonde",
  "block.minecraft.deepslate_emerald_ore": "Minerâl di smeralt in ardesie profonde",
  "block.minecraft.deepslate_gold_ore": "Minerâl di aur in ardesie profonde",
  "block.minecraft.deepslate_iron_ore": "Minerâl di fier in ardesie profonde",
  "block.minecraft.deepslate_lapis_ore": "Minerâl di lapislazuli in ardesie profonde",
  "block.minecraft.deepslate_redstone_ore": "Minerâl di redstone in ardesie profonde",
  "block.minecraft.deepslate_tile_slab": "Lastre di piastrelis di ardesie profonde",
  "block.minecraft.deepslate_tile_stairs": "Scjalins di piastrelis di ardesie profonde",
  "block.minecraft.deepslate_tile_wall": "Muret di piastrelis di ardesie profonde",
  "block.minecraft.deepslate_tiles": "Piastrelis di ardesie profonde",
  "block.minecraft.detector_rail": "Sinis di rilevazion",
  "block.minecraft.diamond_block": "Bloc di diamant",
  "block.minecraft.diamond_ore": "Minerâl di diamant",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Lastre di diorite",
  "block.minecraft.diorite_stairs": "Scjalins di diorite",
  "block.minecraft.diorite_wall": "Muret di diorite",
  "block.minecraft.dirt": "Tiere",
  "block.minecraft.dirt_path": "Piste di teragn",
  "block.minecraft.dispenser": "Distributôr",
  "block.minecraft.dragon_egg": "Ûf di drâc",
  "block.minecraft.dragon_head": "Cjâf di drâc",
  "block.minecraft.dragon_wall_head": "Cjâf di drâc a mûr",
  "block.minecraft.dried_ghast": "Ghast secjât",
  "block.minecraft.dried_kelp_block": "Bloc di alighis secjadis",
  "block.minecraft.dripstone_block": "Bloc di speleoteme",
  "block.minecraft.dropper": "Tiradôr",
  "block.minecraft.emerald_block": "Bloc di smeralt",
  "block.minecraft.emerald_ore": "Minerâl di smeralt",
  "block.minecraft.enchanting_table": "Banc par incjantesims",
  "block.minecraft.end_gateway": "Passaç pal End",
  "block.minecraft.end_portal": "Portâl dal End",
  "block.minecraft.end_portal_frame": "Curnîs dal portâl dal End",
  "block.minecraft.end_rod": "Bachete dal End",
  "block.minecraft.end_stone": "Piere dal End",
  "block.minecraft.end_stone_brick_slab": "Lastre di modons di piere dal End",
  "block.minecraft.end_stone_brick_stairs": "Scjalins di modons di piere dal End",
  "block.minecraft.end_stone_brick_wall": "Muret di modons di piere dal End",
  "block.minecraft.end_stone_bricks": "Modons di piere dal End",
  "block.minecraft.ender_chest": "Baûl dal End",
  "block.minecraft.exposed_chiseled_copper": "Ram ceselât esponût",
  "block.minecraft.exposed_copper": "Ram esponût",
  "block.minecraft.exposed_copper_bars": "Sbaris di ram esponudis",
  "block.minecraft.exposed_copper_bulb": "Lampade di ram esponude",
  "block.minecraft.exposed_copper_chain": "Cjadene di ram esponude",
  "block.minecraft.exposed_copper_chest": "Baûl di ram esponût",
  "block.minecraft.exposed_copper_door": "Puarte di ram esponude",
  "block.minecraft.exposed_copper_golem_statue": "Statue di golem di ram esponude",
  "block.minecraft.exposed_copper_grate": "Grade di ram esponude",
  "block.minecraft.exposed_copper_lantern": "Ferâl di ram esponût",
  "block.minecraft.exposed_copper_trapdoor": "Trabuchel di ram esponût",
  "block.minecraft.exposed_cut_copper": "Ram intaiât esponût",
  "block.minecraft.exposed_cut_copper_slab": "Lastre di ram intaiât esponût",
  "block.minecraft.exposed_cut_copper_stairs": "Scjalins di ram intaiât esponût",
  "block.minecraft.exposed_lightning_rod": "Paresaetis esponût",
  "block.minecraft.farmland": "Teren agricul",
  "block.minecraft.fern": "Felet",
  "block.minecraft.fire": "Fûc",
  "block.minecraft.fire_coral": "Coral des flamis",
  "block.minecraft.fire_coral_block": "Bloc di coral des flamis",
  "block.minecraft.fire_coral_fan": "Gorgonie dal coral des flamis",
  "block.minecraft.fire_coral_wall_fan": "Gorgonie su mûr dal coral des flamis",
  "block.minecraft.firefly_bush": "Baraç di lusignis",
  "block.minecraft.fletching_table": "Banc pes frecis",
  "block.minecraft.flower_pot": "Vâs",
  "block.minecraft.flowering_azalea": "Azalee floride",
  "block.minecraft.flowering_azalea_leaves": "Fueis di azalee floride",
  "block.minecraft.frogspawn": "Ûfs di crot",
  "block.minecraft.frosted_ice": "Aghe inglaçade",
  "block.minecraft.furnace": "Fornâs",
  "block.minecraft.gilded_blackstone": "Pierenere dorade",
  "block.minecraft.glass": "Veri",
  "block.minecraft.glass_pane": "Panel di veri",
  "block.minecraft.glow_lichen": "Lichen luminessent",
  "block.minecraft.glowstone": "Piere luminose",
  "block.minecraft.gold_block": "Bloc di aur",
  "block.minecraft.gold_ore": "Minerâl di aur",
  "block.minecraft.golden_dandelion": "Tale dorade",
  "block.minecraft.granite": "Granît",
  "block.minecraft.granite_slab": "Lastre di granît",
  "block.minecraft.granite_stairs": "Scjalins di granît",
  "block.minecraft.granite_wall": "Muret di granît",
  "block.minecraft.grass": "Jerbe",
  "block.minecraft.grass_block": "Bloc di jerbe",
  "block.minecraft.gravel": "Glerie",
  "block.minecraft.gray_banner": "Stendart grîs",
  "block.minecraft.gray_bed": "Jet grîs",
  "block.minecraft.gray_candle": "Cjandele grise",
  "block.minecraft.gray_candle_cake": "Torte cun cjandele grise",
  "block.minecraft.gray_carpet": "Tapêt grîs",
  "block.minecraft.gray_concrete": "Beton grîs",
  "block.minecraft.gray_concrete_powder": "Beton grîs in polvar",
  "block.minecraft.gray_glazed_terracotta": "Crep dât di smalt grîs",
  "block.minecraft.gray_shulker_box": "Scjatule di shulker grise",
  "block.minecraft.gray_stained_glass": "Veri colorât di grîs",
  "block.minecraft.gray_stained_glass_pane": "Panel di veri colôr grîs",
  "block.minecraft.gray_terracotta": "Crep grîs",
  "block.minecraft.gray_wool": "Lane grise",
  "block.minecraft.green_banner": "Stendart vert",
  "block.minecraft.green_bed": "Jet vert",
  "block.minecraft.green_candle": "Cjandele verde",
  "block.minecraft.green_candle_cake": "Torte cun cjandele verde",
  "block.minecraft.green_carpet": "Tapêt vert",
  "block.minecraft.green_concrete": "Beton vert",
  "block.minecraft.green_concrete_powder": "Beton vert in polvar",
  "block.minecraft.green_glazed_terracotta": "Crep dât di smalt vert",
  "block.minecraft.green_shulker_box": "Scjatule di shulker verde",
  "block.minecraft.green_stained_glass": "Veri colorât di vert",
  "block.minecraft.green_stained_glass_pane": "Panel di veri colôr vert",
  "block.minecraft.green_terracotta": "Crep vert",
  "block.minecraft.green_wool": "Lane verde",
  "block.minecraft.grindstone": "Muele",
  "block.minecraft.hanging_roots": "Lidrîs che a pendulin",
  "block.minecraft.hay_block": "Bale di fen",
  "block.minecraft.heavy_core": "Nucli pesant",
  "block.minecraft.heavy_weighted_pressure_plate": "Plache di pression par pês elevâts",
  "block.minecraft.honey_block": "Bloc di mîl",
  "block.minecraft.honeycomb_block": "Bloc di celets",
  "block.minecraft.hopper": "Tramuele",
  "block.minecraft.horn_coral": "Coral dai cuars",
  "block.minecraft.horn_coral_block": "Bloc di coral dai cuars",
  "block.minecraft.horn_coral_fan": "Gorgonie dal coral dai cuars",
  "block.minecraft.horn_coral_wall_fan": "Gorgonie su mûr dal coral dai cuars",
  "block.minecraft.ice": "Glace",
  "block.minecraft.infested_chiseled_stone_bricks": "Modons di piere ceselâts e infestâts",
  "block.minecraft.infested_cobblestone": "Claps infestâts",
  "block.minecraft.infested_cracked_stone_bricks": "Modons di piere crepâts e infestâts",
  "block.minecraft.infested_deepslate": "Ardesie profonde infestade",
  "block.minecraft.infested_mossy_stone_bricks": "Modons di piere cun muscli infestâts",
  "block.minecraft.infested_stone": "Piere infestade",
  "block.minecraft.infested_stone_bricks": "Modons di piere infestâts",
  "block.minecraft.iron_bars": "Sbaris di fier",
  "block.minecraft.iron_block": "Bloc di fier",
  "block.minecraft.iron_chain": "Cjadene di fier",
  "block.minecraft.iron_door": "Puarte di fier",
  "block.minecraft.iron_ore": "Minerâl di fier",
  "block.minecraft.iron_trapdoor": "Trabuchel di fier",
  "block.minecraft.jack_o_lantern": "Ferâl di coce",
  "block.minecraft.jigsaw": "Bloc berdei",
  "block.minecraft.jukebox": "Zirediscs",
  "block.minecraft.jungle_button": "Boton di len di jungle",
  "block.minecraft.jungle_door": "Puarte di len di jungle",
  "block.minecraft.jungle_fence": "Stangjaçade in len di jungle",
  "block.minecraft.jungle_fence_gate": "Portonut in len di jungle",
  "block.minecraft.jungle_hanging_sign": "Insegne di len di jungle",
  "block.minecraft.jungle_leaves": "Fueis di jungle",
  "block.minecraft.jungle_log": "Tronc di jungle",
  "block.minecraft.jungle_planks": "Breis di len di jungle",
  "block.minecraft.jungle_pressure_plate": "Plache di pression di len di jungle",
  "block.minecraft.jungle_sapling": "Arbossit di jungle",
  "block.minecraft.jungle_shelf": "Scansie di len di jungle",
  "block.minecraft.jungle_sign": "Cartel di len di jungle",
  "block.minecraft.jungle_slab": "Lastre di len di jungle",
  "block.minecraft.jungle_stairs": "Scjalins di len di jungle",
  "block.minecraft.jungle_trapdoor": "Trabuchel di len di jungle",
  "block.minecraft.jungle_wall_hanging_sign": "Insegne di parêt di len di jungle",
  "block.minecraft.jungle_wall_sign": "Targhe di parêt in len di jungle",
  "block.minecraft.jungle_wood": "Len di jungle",
  "block.minecraft.kelp": "Alighe",
  "block.minecraft.kelp_plant": "Gjambe di alighe",
  "block.minecraft.ladder": "Scjale a man",
  "block.minecraft.lantern": "Ferâl",
  "block.minecraft.lapis_block": "Bloc di lapislazuli",
  "block.minecraft.lapis_ore": "Minerâl di lapislazuli",
  "block.minecraft.large_amethyst_bud": "Gjeme di ametiste grande",
  "block.minecraft.large_fern": "Felet grant",
  "block.minecraft.lava": "Lave",
  "block.minecraft.lava_cauldron": "Cjalderon di lave",
  "block.minecraft.leaf_litter": "Grum di fueis",
  "block.minecraft.lectern": "Letorin",
  "block.minecraft.lever": "Jeve",
  "block.minecraft.light": "Lûs",
  "block.minecraft.light_blue_banner": "Stendart blu clâr",
  "block.minecraft.light_blue_bed": "Jet blu clâr",
  "block.minecraft.light_blue_candle": "Cjandele blu clâr",
  "block.minecraft.light_blue_candle_cake": "Torte cun cjandele blu clâr",
  "block.minecraft.light_blue_carpet": "Tapêt blu clâr",
  "block.minecraft.light_blue_concrete": "Beton blu clâr",
  "block.minecraft.light_blue_concrete_powder": "Beton blu clâr in polvar",
  "block.minecraft.light_blue_glazed_terracotta": "Crep dât di smalt blu clâr",
  "block.minecraft.light_blue_shulker_box": "Scjatule di shulker blu clâr",
  "block.minecraft.light_blue_stained_glass": "Veri colorât di blu clâr",
  "block.minecraft.light_blue_stained_glass_pane": "Panel di veri colôr blu clâr",
  "block.minecraft.light_blue_terracotta": "Crep blu clâr",
  "block.minecraft.light_blue_wool": "Lane blu clâr",
  "block.minecraft.light_gray_banner": "Stendart grîs clâr",
  "block.minecraft.light_gray_bed": "Jet grîs clâr",
  "block.minecraft.light_gray_candle": "Cjandele grîs clâr",
  "block.minecraft.light_gray_candle_cake": "Torte cun cjandele grîs clâr",
  "block.minecraft.light_gray_carpet": "Tapêt grîs clâr",
  "block.minecraft.light_gray_concrete": "Beton grîs clâr",
  "block.minecraft.light_gray_concrete_powder": "Beton grîs clâr in polvar",
  "block.minecraft.light_gray_glazed_terracotta": "Crep dât di smalt grîs clâr",
  "block.minecraft.light_gray_shulker_box": "Scjatule di shulker grîs clâr",
  "block.minecraft.light_gray_stained_glass": "Veri colorât di grîs clâr",
  "block.minecraft.light_gray_stained_glass_pane": "Panel di veri colôr grîs clâr",
  "block.minecraft.light_gray_terracotta": "Crep grîs clâr",
  "block.minecraft.light_gray_wool": "Lane grîs clâr",
  "block.minecraft.light_weighted_pressure_plate": "Plache di pression par pês lizêrs",
  "block.minecraft.lightning_rod": "Paresaetis",
  "block.minecraft.lilac": "Lile",
  "block.minecraft.lily_of_the_valley": "Sigjîl di Salomon",
  "block.minecraft.lily_pad": "Lavaç di aghe",
  "block.minecraft.lime_banner": "Stendart vert limon",
  "block.minecraft.lime_bed": "Jet vert limon",
  "block.minecraft.lime_candle": "Cjandele vert limon",
  "block.minecraft.lime_candle_cake": "Torte cun cjandele vert limon",
  "block.minecraft.lime_carpet": "Tapêt vert limon",
  "block.minecraft.lime_concrete": "Beton vert limon",
  "block.minecraft.lime_concrete_powder": "Beton vert limon in polvar",
  "block.minecraft.lime_glazed_terracotta": "Crep dât di smalt vert limon",
  "block.minecraft.lime_shulker_box": "Scjatule di shulker vert limon",
  "block.minecraft.lime_stained_glass": "Veri colorât di vert limon",
  "block.minecraft.lime_stained_glass_pane": "Panel di veri colôr vert limon",
  "block.minecraft.lime_terracotta": "Crep vert limon",
  "block.minecraft.lime_wool": "Lane vert limon",
  "block.minecraft.lodestone": "Magnetite",
  "block.minecraft.loom": "Telâr",
  "block.minecraft.magenta_banner": "Stendart magenta",
  "block.minecraft.magenta_bed": "Jet magenta",
  "block.minecraft.magenta_candle": "Cjandele magenta",
  "block.minecraft.magenta_candle_cake": "Torte cun cjandele magenta",
  "block.minecraft.magenta_carpet": "Tapêt magenta",
  "block.minecraft.magenta_concrete": "Beton magenta",
  "block.minecraft.magenta_concrete_powder": "Beton magenta in polvar",
  "block.minecraft.magenta_glazed_terracotta": "Crep dât di smalt magenta",
  "block.minecraft.magenta_shulker_box": "Scjatule di shulker magenta",
  "block.minecraft.magenta_stained_glass": "Veri colorât di magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel di veri colôr magenta",
  "block.minecraft.magenta_terracotta": "Crep magenta",
  "block.minecraft.magenta_wool": "Lane magenta",
  "block.minecraft.magma_block": "Bloc di magme",
  "block.minecraft.mangrove_button": "Boton di mangrovie",
  "block.minecraft.mangrove_door": "Puarte di mangrovie",
  "block.minecraft.mangrove_fence": "Stangjaçade di mangrovie",
  "block.minecraft.mangrove_fence_gate": "Portonut di mangrovie",
  "block.minecraft.mangrove_hanging_sign": "Insegne di mangrovie",
  "block.minecraft.mangrove_leaves": "Fueis di mangrovie",
  "block.minecraft.mangrove_log": "Tronc di mangrovie",
  "block.minecraft.mangrove_planks": "Breis di mangrovie",
  "block.minecraft.mangrove_pressure_plate": "Plache di pression di mangrovie",
  "block.minecraft.mangrove_propagule": "Propagul di mangrovie",
  "block.minecraft.mangrove_roots": "Lidrîs di mangrovie",
  "block.minecraft.mangrove_shelf": "Scansie di mangrovie",
  "block.minecraft.mangrove_sign": "Cartel di mangrovie",
  "block.minecraft.mangrove_slab": "Lastre di mangrovie",
  "block.minecraft.mangrove_stairs": "Scjalins di mangrovie",
  "block.minecraft.mangrove_trapdoor": "Trabuchel di mangrovie",
  "block.minecraft.mangrove_wall_hanging_sign": "Insegne di parêt di mangrovie",
  "block.minecraft.mangrove_wall_sign": "Targhe di parêt di mangrovie",
  "block.minecraft.mangrove_wood": "Len di mangrovie",
  "block.minecraft.medium_amethyst_bud": "Gjeme di ametiste medie",
  "block.minecraft.melon": "Angurie",
  "block.minecraft.melon_stem": "Stoc di angurie",
  "block.minecraft.moss_block": "Bloc di muscli",
  "block.minecraft.moss_carpet": "Tapêt di muscli",
  "block.minecraft.mossy_cobblestone": "Claps cun muscli",
  "block.minecraft.mossy_cobblestone_slab": "Lastre di claps cun muscli",
  "block.minecraft.mossy_cobblestone_stairs": "Scjalins di claps cun muscli",
  "block.minecraft.mossy_cobblestone_wall": "Muret di claps cul muscli",
  "block.minecraft.mossy_stone_brick_slab": "Lastre di modons di piere cun muscli",
  "block.minecraft.mossy_stone_brick_stairs": "Scjalins di modons di piere cun muscli",
  "block.minecraft.mossy_stone_brick_wall": "Muret di modons di piere cun muscli",
  "block.minecraft.mossy_stone_bricks": "Modons di piere cul muscli",
  "block.minecraft.moving_piston": "Piston in moviment",
  "block.minecraft.mud": "Pantan",
  "block.minecraft.mud_brick_slab": "Lastre di modons di pantan",
  "block.minecraft.mud_brick_stairs": "Scjalins di modons di pantan",
  "block.minecraft.mud_brick_wall": "Muret di modons di pantan",
  "block.minecraft.mud_bricks": "Modons di pantan",
  "block.minecraft.muddy_mangrove_roots": "Lidrîs di mangrovie impantanadis",
  "block.minecraft.mushroom_stem": "Gjambe di fonc",
  "block.minecraft.mycelium": "Miceli",
  "block.minecraft.nether_brick_fence": "Stangjaçade di modons dal Nether",
  "block.minecraft.nether_brick_slab": "Lastre di modons dal Nether",
  "block.minecraft.nether_brick_stairs": "Scjalins di modons dal Nether",
  "block.minecraft.nether_brick_wall": "Muret di modons dal Nether",
  "block.minecraft.nether_bricks": "Modons dal Nether",
  "block.minecraft.nether_gold_ore": "Minerâl di aur dal Nether",
  "block.minecraft.nether_portal": "Portâl pal Nether",
  "block.minecraft.nether_quartz_ore": "Minerâl di cuarç dal Nether",
  "block.minecraft.nether_sprouts": "Menadis dal Nether",
  "block.minecraft.nether_wart": "Riçûl dal Nether",
  "block.minecraft.nether_wart_block": "Bloc di riçûi dal Nether",
  "block.minecraft.netherite_block": "Bloc di netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc sonôr",
  "block.minecraft.oak_button": "Boton di rôl",
  "block.minecraft.oak_door": "Puarte di rôl",
  "block.minecraft.oak_fence": "Stangjaçade di rôl",
  "block.minecraft.oak_fence_gate": "Portonut di rôl",
  "block.minecraft.oak_hanging_sign": "Insegne di rôl",
  "block.minecraft.oak_leaves": "Fueis di rôl",
  "block.minecraft.oak_log": "Tronc di rôl",
  "block.minecraft.oak_planks": "Breis di rôl",
  "block.minecraft.oak_pressure_plate": "Plache di pression di rôl",
  "block.minecraft.oak_sapling": "Arbossit di rôl",
  "block.minecraft.oak_shelf": "Scansie di rôl",
  "block.minecraft.oak_sign": "Cartel di rôl",
  "block.minecraft.oak_slab": "Lastre di rôl",
  "block.minecraft.oak_stairs": "Scjalins di rôl",
  "block.minecraft.oak_trapdoor": "Trabuchel di rôl",
  "block.minecraft.oak_wall_hanging_sign": "Insegne di parêt di rôl",
  "block.minecraft.oak_wall_sign": "Targhe di parêt di rôl",
  "block.minecraft.oak_wood": "Len di rôl",
  "block.minecraft.observer": "Osservadôr",
  "block.minecraft.obsidian": "Ossidiane",
  "block.minecraft.ochre_froglight": "Crot-lûs colôr auriane",
  "block.minecraft.ominous_banner": "Stendart dal malauguri",
  "block.minecraft.open_eyeblossom": "Rose-voli vierte",
  "block.minecraft.orange_banner": "Stendart naranç",
  "block.minecraft.orange_bed": "Jet naranç",
  "block.minecraft.orange_candle": "Cjandele naranç",
  "block.minecraft.orange_candle_cake": "Torte cun cjandele naranç",
  "block.minecraft.orange_carpet": "Tapêt naranç",
  "block.minecraft.orange_concrete": "Beton naranç",
  "block.minecraft.orange_concrete_powder": "Beton naranç in polvar",
  "block.minecraft.orange_glazed_terracotta": "Crep dât di smalt naranç",
  "block.minecraft.orange_shulker_box": "Scjatule di shulker naranç",
  "block.minecraft.orange_stained_glass": "Veri colorât di naranç",
  "block.minecraft.orange_stained_glass_pane": "Panel di veri colôr naranç",
  "block.minecraft.orange_terracotta": "Crep naranç",
  "block.minecraft.orange_tulip": "Tulipan naranç",
  "block.minecraft.orange_wool": "Lane naranç",
  "block.minecraft.oxeye_daisy": "Margarite",
  "block.minecraft.oxidized_chiseled_copper": "Ram ceselât ossidât",
  "block.minecraft.oxidized_copper": "Ram ossidât",
  "block.minecraft.oxidized_copper_bars": "Sbaris di ram ossidadis",
  "block.minecraft.oxidized_copper_bulb": "Lampade di ram ossidade",
  "block.minecraft.oxidized_copper_chain": "Cjadene di ram ossidade",
  "block.minecraft.oxidized_copper_chest": "Baûl di ram ossidât",
  "block.minecraft.oxidized_copper_door": "Puarte di ram ossidade",
  "block.minecraft.oxidized_copper_golem_statue": "Statue di golem di ram ossidade",
  "block.minecraft.oxidized_copper_grate": "Grade di ram ossidade",
  "block.minecraft.oxidized_copper_lantern": "Ferâl di ram ossidât",
  "block.minecraft.oxidized_copper_trapdoor": "Trabuchel di ram ossidât",
  "block.minecraft.oxidized_cut_copper": "Ram intaiât ossidât",
  "block.minecraft.oxidized_cut_copper_slab": "Lastre di ram intaiât ossidât",
  "block.minecraft.oxidized_cut_copper_stairs": "Scjalins di ram intaiât ossidât",
  "block.minecraft.oxidized_lightning_rod": "Paresaetis ossidât",
  "block.minecraft.packed_ice": "Glaç pressât",
  "block.minecraft.packed_mud": "Pantan penç",
  "block.minecraft.pale_hanging_moss": "Muscli palit che al pendule",
  "block.minecraft.pale_moss_block": "Bloc di muscli palit",
  "block.minecraft.pale_moss_carpet": "Tapêt di muscli palit",
  "block.minecraft.pale_oak_button": "Boton di rôl palit",
  "block.minecraft.pale_oak_door": "Puarte di rôl palit",
  "block.minecraft.pale_oak_fence": "Stangjaçade di rôl palit",
  "block.minecraft.pale_oak_fence_gate": "Portonut di rôl palit",
  "block.minecraft.pale_oak_hanging_sign": "Insegne di rôl palit",
  "block.minecraft.pale_oak_leaves": "Fueis di rôl palit",
  "block.minecraft.pale_oak_log": "Tronc di rôl palit",
  "block.minecraft.pale_oak_planks": "Breis di rôl palit",
  "block.minecraft.pale_oak_pressure_plate": "Plache di pression di rôl palit",
  "block.minecraft.pale_oak_sapling": "Arbossit di rôl palit",
  "block.minecraft.pale_oak_shelf": "Scansie di rôl palit",
  "block.minecraft.pale_oak_sign": "Cartel di rôl palit",
  "block.minecraft.pale_oak_slab": "Lastre di rôl palit",
  "block.minecraft.pale_oak_stairs": "Scjalins di rôl palit",
  "block.minecraft.pale_oak_trapdoor": "Trabuchel di rôl palit",
  "block.minecraft.pale_oak_wall_hanging_sign": "Insegne di parêt di rôl palit",
  "block.minecraft.pale_oak_wall_sign": "Targhe di parêt di rôl palit",
  "block.minecraft.pale_oak_wood": "Len di rôl palit",
  "block.minecraft.pearlescent_froglight": "Crot-lûs colôr perle",
  "block.minecraft.peony": "Peonie",
  "block.minecraft.petrified_oak_slab": "Lastre di rôl impetride",
  "block.minecraft.piglin_head": "Cjâf di piglin",
  "block.minecraft.piglin_wall_head": "Cjâf di piglin a mûr",
  "block.minecraft.pink_banner": "Stendart rose",
  "block.minecraft.pink_bed": "Jet rose",
  "block.minecraft.pink_candle": "Cjandele rose",
  "block.minecraft.pink_candle_cake": "Torte cun cjandele rose",
  "block.minecraft.pink_carpet": "Tapêt rose",
  "block.minecraft.pink_concrete": "Beton rose",
  "block.minecraft.pink_concrete_powder": "Beton rose in polvar",
  "block.minecraft.pink_glazed_terracotta": "Crep dât di smalt rose",
  "block.minecraft.pink_petals": "Pics rose",
  "block.minecraft.pink_shulker_box": "Scjatule di shulker rose",
  "block.minecraft.pink_stained_glass": "Veri colorât di rose",
  "block.minecraft.pink_stained_glass_pane": "Panel di veri colôr rose",
  "block.minecraft.pink_terracotta": "Crep rose",
  "block.minecraft.pink_tulip": "Tulipan rose",
  "block.minecraft.pink_wool": "Lane rose",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Cjâf dal piston",
  "block.minecraft.pitcher_crop": "Colture di plante bocâl",
  "block.minecraft.pitcher_plant": "Plante bocâl",
  "block.minecraft.player_head": "Cjâf di zuiadôr",
  "block.minecraft.player_head.named": "Cjâf di %s",
  "block.minecraft.player_wall_head": "Cjâf di zuiadôr a mûr",
  "block.minecraft.podzol": "Tiere grise",
  "block.minecraft.pointed_dripstone": "Speleoteme spiçât",
  "block.minecraft.polished_andesite": "Andesite lustrade",
  "block.minecraft.polished_andesite_slab": "Lastre di andesite lustrade",
  "block.minecraft.polished_andesite_stairs": "Scjalins di andesite lustrade",
  "block.minecraft.polished_basalt": "Basalt lustrât",
  "block.minecraft.polished_blackstone": "Pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_slab": "Lastre di modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_stairs": "Scjalins di modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_brick_wall": "Muret di modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_bricks": "Modons di pierenere lustrade",
  "block.minecraft.polished_blackstone_button": "Boton di pierenere lustrade",
  "block.minecraft.polished_blackstone_pressure_plate": "Plache di pression di pierenere lustrade",
  "block.minecraft.polished_blackstone_slab": "Lastre di pierenere lustrade",
  "block.minecraft.polished_blackstone_stairs": "Scjalins di pierenere lustrade",
  "block.minecraft.polished_blackstone_wall": "Muret di pierenere lustrade",
  "block.minecraft.polished_deepslate": "Ardesie profonde lustrade",
  "block.minecraft.polished_deepslate_slab": "Lastre di ardesie profonde lustrade",
  "block.minecraft.polished_deepslate_stairs": "Scjalins di ardesie profonde lustrade",
  "block.minecraft.polished_deepslate_wall": "Muret di ardesie profonde lustrade",
  "block.minecraft.polished_diorite": "Diorite lustrade",
  "block.minecraft.polished_diorite_slab": "Lastre di diorite lustrade",
  "block.minecraft.polished_diorite_stairs": "Scjalins di diorite lustrade",
  "block.minecraft.polished_granite": "Granît lustrât",
  "block.minecraft.polished_granite_slab": "Lastre di granît lustrât",
  "block.minecraft.polished_granite_stairs": "Scjalins di granît lustrât",
  "block.minecraft.polished_tuff": "Tof lustrât",
  "block.minecraft.polished_tuff_slab": "Lastre di tof lustrât",
  "block.minecraft.polished_tuff_stairs": "Scjalins di tof lustrât",
  "block.minecraft.polished_tuff_wall": "Muret di tof lustrât",
  "block.minecraft.poppy": "Papavar",
  "block.minecraft.potatoes": "Patatis",
  "block.minecraft.potted_acacia_sapling": "Arbossit di agacie in vâs",
  "block.minecraft.potted_allium": "Allium in vâs",
  "block.minecraft.potted_azalea_bush": "Azalee in vâs",
  "block.minecraft.potted_azure_bluet": "Houstonia caerulea in vâs",
  "block.minecraft.potted_bamboo": "Bambù in vâs",
  "block.minecraft.potted_birch_sapling": "Arbossit di bedoi in vâs",
  "block.minecraft.potted_blue_orchid": "Orchidee blu in vâs",
  "block.minecraft.potted_brown_mushroom": "Fonc maron in vâs",
  "block.minecraft.potted_cactus": "Cactus in vâs",
  "block.minecraft.potted_cherry_sapling": "Arbossit di cjariesâr in vâs",
  "block.minecraft.potted_closed_eyeblossom": "Rose-voli sierade in vâs",
  "block.minecraft.potted_cornflower": "Barburice in vâs",
  "block.minecraft.potted_crimson_fungus": "Fonc cremisin in vâs",
  "block.minecraft.potted_crimson_roots": "Lidrîs cremisinis in vâs",
  "block.minecraft.potted_dandelion": "Tale in vâs",
  "block.minecraft.potted_dark_oak_sapling": "Arbossit di rôl scûr in vâs",
  "block.minecraft.potted_dead_bush": "Sterp sec in vâs",
  "block.minecraft.potted_fern": "Felet in vâs",
  "block.minecraft.potted_flowering_azalea_bush": "Azalee floride in vâs",
  "block.minecraft.potted_golden_dandelion": "Tale dorade in vâs",
  "block.minecraft.potted_jungle_sapling": "Arbossit di jungle in vâs",
  "block.minecraft.potted_lily_of_the_valley": "Sigjîl di Salomon in vâs",
  "block.minecraft.potted_mangrove_propagule": "Propagul di mangrovie in vâs",
  "block.minecraft.potted_oak_sapling": "Arbossit di rôl in vâs",
  "block.minecraft.potted_open_eyeblossom": "Rose-voli vierte in vâs",
  "block.minecraft.potted_orange_tulip": "Tulipan naranç in vâs",
  "block.minecraft.potted_oxeye_daisy": "Margherite in vâs",
  "block.minecraft.potted_pale_oak_sapling": "Arbossit di rôl palit in vâs",
  "block.minecraft.potted_pink_tulip": "Tulipan rose in vâs",
  "block.minecraft.potted_poppy": "Papavar in vâs",
  "block.minecraft.potted_red_mushroom": "Fonc ros in vâs",
  "block.minecraft.potted_red_tulip": "Tulipan ros in vâs",
  "block.minecraft.potted_spruce_sapling": "Arbossit di peç in vâs",
  "block.minecraft.potted_torchflower": "Rose-torce in vâs",
  "block.minecraft.potted_warped_fungus": "Fonc disnaturât in vâs",
  "block.minecraft.potted_warped_roots": "Lidrîs disnaturadis in vâs",
  "block.minecraft.potted_white_tulip": "Tulipan blanc in vâs",
  "block.minecraft.potted_wither_rose": "Rose di Wither in vâs",
  "block.minecraft.powder_snow": "Nêf farinose",
  "block.minecraft.powder_snow_cauldron": "Cjalderon di nêf farinose",
  "block.minecraft.powered_rail": "Sinis alimentadis",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Lastre di modons di prismarine",
  "block.minecraft.prismarine_brick_stairs": "Scjalins di modons di prismarine",
  "block.minecraft.prismarine_bricks": "Modons di prismarine",
  "block.minecraft.prismarine_slab": "Lastre di prismarine",
  "block.minecraft.prismarine_stairs": "Scjalins di prismarine",
  "block.minecraft.prismarine_wall": "Muret di prismarine",
  "block.minecraft.pumpkin": "Coce",
  "block.minecraft.pumpkin_stem": "Stoc de coce",
  "block.minecraft.purple_banner": "Stendart viole",
  "block.minecraft.purple_bed": "Jet viole",
  "block.minecraft.purple_candle": "Cjandele viole",
  "block.minecraft.purple_candle_cake": "Torte cun cjandele viole",
  "block.minecraft.purple_carpet": "Tapêt viole",
  "block.minecraft.purple_concrete": "Beton viole",
  "block.minecraft.purple_concrete_powder": "Beton viole in polvar",
  "block.minecraft.purple_glazed_terracotta": "Crep dât di smalt viole",
  "block.minecraft.purple_shulker_box": "Scjatule di shulker viole",
  "block.minecraft.purple_stained_glass": "Veri colorât di viole",
  "block.minecraft.purple_stained_glass_pane": "Panel di veri colôr viole",
  "block.minecraft.purple_terracotta": "Crep viole",
  "block.minecraft.purple_wool": "Lane viole",
  "block.minecraft.purpur_block": "Bloc di Purpur",
  "block.minecraft.purpur_pillar": "Pilastri di Purpur",
  "block.minecraft.purpur_slab": "Lastre di Purpur",
  "block.minecraft.purpur_stairs": "Scjalins di Purpur",
  "block.minecraft.quartz_block": "Bloc di cuarç",
  "block.minecraft.quartz_bricks": "Modons di cuarç",
  "block.minecraft.quartz_pillar": "Pilastri di cuarç",
  "block.minecraft.quartz_slab": "Lastre di cuarç",
  "block.minecraft.quartz_stairs": "Scjalins di cuarç",
  "block.minecraft.rail": "Sinis",
  "block.minecraft.raw_copper_block": "Bloc di ram grês",
  "block.minecraft.raw_gold_block": "Bloc di aur grês",
  "block.minecraft.raw_iron_block": "Bloc di fier grês",
  "block.minecraft.red_banner": "Stendart ros",
  "block.minecraft.red_bed": "Jet ros",
  "block.minecraft.red_candle": "Cjandele rosse",
  "block.minecraft.red_candle_cake": "Torte cun cjandele rosse",
  "block.minecraft.red_carpet": "Tapêt ros",
  "block.minecraft.red_concrete": "Beton ros",
  "block.minecraft.red_concrete_powder": "Beton ros in polvar",
  "block.minecraft.red_glazed_terracotta": "Crep dât di smalt ros",
  "block.minecraft.red_mushroom": "Fonc ros",
  "block.minecraft.red_mushroom_block": "Bloc di fonc ros",
  "block.minecraft.red_nether_brick_slab": "Lastre di modons ros dal Nether",
  "block.minecraft.red_nether_brick_stairs": "Scjalins di modons ros dal Nether",
  "block.minecraft.red_nether_brick_wall": "Muret di modons ros dal Nether",
  "block.minecraft.red_nether_bricks": "Modons ros dal Nether",
  "block.minecraft.red_sand": "Savalon ros",
  "block.minecraft.red_sandstone": "Arenarie rosse",
  "block.minecraft.red_sandstone_slab": "Lastre di arenarie rosse",
  "block.minecraft.red_sandstone_stairs": "Scjalins di arenarie rosse",
  "block.minecraft.red_sandstone_wall": "Muret di arenarie rosse",
  "block.minecraft.red_shulker_box": "Scjatule di shulker rosse",
  "block.minecraft.red_stained_glass": "Veri colorât di ros",
  "block.minecraft.red_stained_glass_pane": "Panel di veri colôr ros",
  "block.minecraft.red_terracotta": "Crep ros",
  "block.minecraft.red_tulip": "Tulipan ros",
  "block.minecraft.red_wool": "Lane rosse",
  "block.minecraft.redstone_block": "Bloc di redstone",
  "block.minecraft.redstone_lamp": "Lampade di redstone",
  "block.minecraft.redstone_ore": "Minerâl di redstone",
  "block.minecraft.redstone_torch": "Torce di redstone",
  "block.minecraft.redstone_wall_torch": "Torce di parêt di redstone",
  "block.minecraft.redstone_wire": "Fîl di redstone",
  "block.minecraft.reinforced_deepslate": "Ardesie profonde rinfuarçade",
  "block.minecraft.repeater": "Ripetidôr di redstone",
  "block.minecraft.repeating_command_block": "Bloc comants ripetûts",
  "block.minecraft.resin_block": "Bloc di resine",
  "block.minecraft.resin_brick_slab": "Lastre di modons di resine",
  "block.minecraft.resin_brick_stairs": "Scjalins di modons di resine",
  "block.minecraft.resin_brick_wall": "Muret di modons di resine",
  "block.minecraft.resin_bricks": "Modons di resine",
  "block.minecraft.resin_clump": "Grop di resine",
  "block.minecraft.respawn_anchor": "Ancure di rinassite",
  "block.minecraft.rooted_dirt": "Tiere cun lidrîs",
  "block.minecraft.rose_bush": "Baraç di rosis",
  "block.minecraft.sand": "Savalon",
  "block.minecraft.sandstone": "Arenarie",
  "block.minecraft.sandstone_slab": "Lastre di arenarie",
  "block.minecraft.sandstone_stairs": "Scjalins di arenarie",
  "block.minecraft.sandstone_wall": "Muret di arenarie",
  "block.minecraft.scaffolding": "Impalcadure",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizadôr di Sculk",
  "block.minecraft.sculk_sensor": "Sensôr di Sculk",
  "block.minecraft.sculk_shrieker": "Sculk zigon",
  "block.minecraft.sculk_vein": "Vene di Sculk",
  "block.minecraft.sea_lantern": "Ferâl dai mârs",
  "block.minecraft.sea_pickle": "Cudumar di mâr",
  "block.minecraft.seagrass": "Jerbe dal mâr",
  "block.minecraft.set_spawn": "Pont di rinassite stabilît",
  "block.minecraft.short_dry_grass": "Jerbe secje basse",
  "block.minecraft.short_grass": "Jerbe basse",
  "block.minecraft.shroomlight": "Fonclum",
  "block.minecraft.shulker_box": "Scjatule di shulker",
  "block.minecraft.skeleton_skull": "Crani di scheletri",
  "block.minecraft.skeleton_wall_skull": "Crani di scheletri a mûr",
  "block.minecraft.slime_block": "Bloc di gjeladine",
  "block.minecraft.small_amethyst_bud": "Gjeme di ametiste piçule",
  "block.minecraft.small_dripleaf": "Planteforme piçule",
  "block.minecraft.smithing_table": "Banc dal fari",
  "block.minecraft.smoker": "Fumadôr",
  "block.minecraft.smooth_basalt": "Basalt sliss",
  "block.minecraft.smooth_quartz": "Bloc di cuarç slis",
  "block.minecraft.smooth_quartz_slab": "Lastre di cuarç slis",
  "block.minecraft.smooth_quartz_stairs": "Scjalins di cuarç slis",
  "block.minecraft.smooth_red_sandstone": "Arearie rosse slisse",
  "block.minecraft.smooth_red_sandstone_slab": "Lastre di arenarie rosse slisse",
  "block.minecraft.smooth_red_sandstone_stairs": "Scjalins di arenarie rosse slisse",
  "block.minecraft.smooth_sandstone": "Arenarie slisse",
  "block.minecraft.smooth_sandstone_slab": "Lastre di arenarie slisse",
  "block.minecraft.smooth_sandstone_stairs": "Scjalins di arenarie slisse",
  "block.minecraft.smooth_stone": "Piere slisse",
  "block.minecraft.smooth_stone_slab": "Lastre di piere slisse",
  "block.minecraft.sniffer_egg": "Ûf di nasadôr",
  "block.minecraft.snow": "Nêf",
  "block.minecraft.snow_block": "Bloc di nêf",
  "block.minecraft.soul_campfire": "Fogaron des animis",
  "block.minecraft.soul_fire": "Fûc des animis",
  "block.minecraft.soul_lantern": "Ferâl des animis",
  "block.minecraft.soul_sand": "Savalon des animis",
  "block.minecraft.soul_soil": "Tiere des animis",
  "block.minecraft.soul_torch": "Torce des animis",
  "block.minecraft.soul_wall_torch": "Torce des animis di parêt",
  "block.minecraft.spawn.not_valid": "No tu âs un jet to o une ancure di rinassite cjariade, opûr a son ostruîts",
  "block.minecraft.spawner": "Generadôr di mostris",
  "block.minecraft.spawner.desc1": "Interagjiss cun l'uf di nassite:",
  "block.minecraft.spawner.desc2": "Imposte il gjenar di creature",
  "block.minecraft.sponge": "Sponze",
  "block.minecraft.spore_blossom": "Rose soporifare",
  "block.minecraft.spruce_button": "Boton di peç",
  "block.minecraft.spruce_door": "Puarte di peç",
  "block.minecraft.spruce_fence": "Stangjaçade di peç",
  "block.minecraft.spruce_fence_gate": "Portonut di peç",
  "block.minecraft.spruce_hanging_sign": "Insegne di peç",
  "block.minecraft.spruce_leaves": "Fueis di peç",
  "block.minecraft.spruce_log": "Tronc di peç",
  "block.minecraft.spruce_planks": "Breis di peç",
  "block.minecraft.spruce_pressure_plate": "Plache di pression di peç",
  "block.minecraft.spruce_sapling": "Arbossit di peç",
  "block.minecraft.spruce_shelf": "Scansie di peç",
  "block.minecraft.spruce_sign": "Cartel di peç",
  "block.minecraft.spruce_slab": "Lastre di peç",
  "block.minecraft.spruce_stairs": "Scjalins di peç",
  "block.minecraft.spruce_trapdoor": "Trabuchel di peç",
  "block.minecraft.spruce_wall_hanging_sign": "Insegne di parêt di peç",
  "block.minecraft.spruce_wall_sign": "Targhe di parêt di peç",
  "block.minecraft.spruce_wood": "Len di peç",
  "block.minecraft.sticky_piston": "Piston tacadiç",
  "block.minecraft.stone": "Piere",
  "block.minecraft.stone_brick_slab": "Lastre di modons di piere",
  "block.minecraft.stone_brick_stairs": "Scjalins di modons di piere",
  "block.minecraft.stone_brick_wall": "Muret di modons di piere",
  "block.minecraft.stone_bricks": "Modons di piere",
  "block.minecraft.stone_button": "Boton di piere",
  "block.minecraft.stone_pressure_plate": "Plache di pression di piere",
  "block.minecraft.stone_slab": "Lastre di piere",
  "block.minecraft.stone_stairs": "Scjalins di piere",
  "block.minecraft.stonecutter": "Taiadôr di pieris",
  "block.minecraft.stripped_acacia_log": "Tronc di agacie spelât",
  "block.minecraft.stripped_acacia_wood": "Len di agacie spelât",
  "block.minecraft.stripped_bamboo_block": "Bloc di bambù stripiât",
  "block.minecraft.stripped_birch_log": "Tronc di bedoi spelât",
  "block.minecraft.stripped_birch_wood": "Len di bedoi spelât",
  "block.minecraft.stripped_cherry_log": "Tronc di cjariesâr spelât",
  "block.minecraft.stripped_cherry_wood": "Len di cjariesâr spelât",
  "block.minecraft.stripped_crimson_hyphae": "Ifis cremisinis sbroiadis",
  "block.minecraft.stripped_crimson_stem": "Tronc cremisin spelât",
  "block.minecraft.stripped_dark_oak_log": "Tronc di rôl scûr spelât",
  "block.minecraft.stripped_dark_oak_wood": "Len di rôl scûr spelât",
  "block.minecraft.stripped_jungle_log": "Tronc di jungle spelât",
  "block.minecraft.stripped_jungle_wood": "Len di jungle spelât",
  "block.minecraft.stripped_mangrove_log": "Tronc di mangrovie spelât",
  "block.minecraft.stripped_mangrove_wood": "Len di mangrovie spelât",
  "block.minecraft.stripped_oak_log": "Tronc di rôl spelât",
  "block.minecraft.stripped_oak_wood": "Len di rôl spelât",
  "block.minecraft.stripped_pale_oak_log": "Tronc di rôl palit spelât",
  "block.minecraft.stripped_pale_oak_wood": "Len di rôl palit spelât",
  "block.minecraft.stripped_spruce_log": "Tronc di peç spelât",
  "block.minecraft.stripped_spruce_wood": "Len di peç spelât",
  "block.minecraft.stripped_warped_hyphae": "Ifis disnaturadis sbroiadis",
  "block.minecraft.stripped_warped_stem": "Tronc disnaturât spelât",
  "block.minecraft.structure_block": "Bloc di struture",
  "block.minecraft.structure_void": "Vueit di struture",
  "block.minecraft.sugar_cane": "Cjane di sucar",
  "block.minecraft.sunflower": "Gjirasol",
  "block.minecraft.suspicious_gravel": "Glerie suspiete",
  "block.minecraft.suspicious_sand": "Savalon suspiet",
  "block.minecraft.sweet_berry_bush": "Baraç des pomulis dolcis",
  "block.minecraft.tall_dry_grass": "Jerbe secje alte",
  "block.minecraft.tall_grass": "Jerbe alte",
  "block.minecraft.tall_seagrass": "Jerbe dal mâr alte",
  "block.minecraft.target": "Bersai",
  "block.minecraft.terracotta": "Crep",
  "block.minecraft.test_block": "Bloc di prove",
  "block.minecraft.test_instance_block": "Bloc di istance di prove",
  "block.minecraft.tinted_glass": "Veri scurît",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Lis esplosions di TNT a son disativadis",
  "block.minecraft.torch": "Torce",
  "block.minecraft.torchflower": "Rose-torce",
  "block.minecraft.torchflower_crop": "Plante di rose-torce",
  "block.minecraft.trapped_chest": "Baûl trapule",
  "block.minecraft.trial_spawner": "Gjeneradôr de prove",
  "block.minecraft.tripwire": "Fîl di lescjament",
  "block.minecraft.tripwire_hook": "Ganç pal fîl di lescjament",
  "block.minecraft.tube_coral": "Coral dai tubui",
  "block.minecraft.tube_coral_block": "Bloc di coral dai tubui",
  "block.minecraft.tube_coral_fan": "Gorgonie dal coral dai tubui",
  "block.minecraft.tube_coral_wall_fan": "Gorgonie su mûr dal coral dai tubui",
  "block.minecraft.tuff": "Tof",
  "block.minecraft.tuff_brick_slab": "Lastre di modons di tof",
  "block.minecraft.tuff_brick_stairs": "Scjalins di modons di tof",
  "block.minecraft.tuff_brick_wall": "Muret di modons di tof",
  "block.minecraft.tuff_bricks": "Modons di tof",
  "block.minecraft.tuff_slab": "Lastre di tof",
  "block.minecraft.tuff_stairs": "Scjalins di tof",
  "block.minecraft.tuff_wall": "Muret di tof",
  "block.minecraft.turtle_egg": "Ûf di copasse",
  "block.minecraft.twisting_vines": "Rampighins intorteâts",
  "block.minecraft.twisting_vines_plant": "Plante rampighine intorteade",
  "block.minecraft.vault": "Cassefuarte",
  "block.minecraft.verdant_froglight": "Crot-lûs colôr sverdeant",
  "block.minecraft.vine": "Plante rampighine",
  "block.minecraft.void_air": "Aiar di vueit",
  "block.minecraft.wall_torch": "Torce di parêt",
  "block.minecraft.warped_button": "Boton disnaturât",
  "block.minecraft.warped_door": "Puarte disnaturade",
  "block.minecraft.warped_fence": "Stangjaçade disnaturade",
  "block.minecraft.warped_fence_gate": "Portonut disnaturât",
  "block.minecraft.warped_fungus": "Fonc disnaturât",
  "block.minecraft.warped_hanging_sign": "Insegne disnaturade",
  "block.minecraft.warped_hyphae": "Ifis disnaturadis",
  "block.minecraft.warped_nylium": "Neceli disnaturât",
  "block.minecraft.warped_planks": "Breis disnaturadis",
  "block.minecraft.warped_pressure_plate": "Plache di pression disnaturade",
  "block.minecraft.warped_roots": "Lidrîs disnaturadis",
  "block.minecraft.warped_shelf": "Scansie disnaturade",
  "block.minecraft.warped_sign": "Cartel disnaturât",
  "block.minecraft.warped_slab": "Lastre disnaturade",
  "block.minecraft.warped_stairs": "Scjalins disnaturâts",
  "block.minecraft.warped_stem": "Tronc disnaturât",
  "block.minecraft.warped_trapdoor": "Trabuchel disnaturât",
  "block.minecraft.warped_wall_hanging_sign": "Insegne di parêt disnaturade",
  "block.minecraft.warped_wall_sign": "Targhe di parêt disnaturade",
  "block.minecraft.warped_wart_block": "Bloc di riçûi disnaturât",
  "block.minecraft.water": "Aghe",
  "block.minecraft.water_cauldron": "Cjalderon di aghe",
  "block.minecraft.waxed_chiseled_copper": "Ram ceselât incerât",
  "block.minecraft.waxed_copper_bars": "Sbaris di ram inceradis",
  "block.minecraft.waxed_copper_block": "Bloc incerât di ram",
  "block.minecraft.waxed_copper_bulb": "Lampade di ram incerade",
  "block.minecraft.waxed_copper_chain": "Cjadene di ram incerade",
  "block.minecraft.waxed_copper_chest": "Baûl di ram incerât",
  "block.minecraft.waxed_copper_door": "Puarte di ram incerade",
  "block.minecraft.waxed_copper_golem_statue": "Statue di golem di ram incerade",
  "block.minecraft.waxed_copper_grate": "Grade di ram incerade",
  "block.minecraft.waxed_copper_lantern": "Ferâl di ram incerât",
  "block.minecraft.waxed_copper_trapdoor": "Trabuchel di ram incerât",
  "block.minecraft.waxed_cut_copper": "Ram intaiât incerât",
  "block.minecraft.waxed_cut_copper_slab": "Lastre di ram intaiât incerât",
  "block.minecraft.waxed_cut_copper_stairs": "Scjalins di ram intaiât incerât",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ram ceselât esponût incerât",
  "block.minecraft.waxed_exposed_copper": "Ram esponût incerât",
  "block.minecraft.waxed_exposed_copper_bars": "Sbaris di ram esponudis inceradis",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampade di ram esponude incerade",
  "block.minecraft.waxed_exposed_copper_chain": "Cjadene di ram esponude incerade",
  "block.minecraft.waxed_exposed_copper_chest": "Baûl di ram esponût incerât",
  "block.minecraft.waxed_exposed_copper_door": "Puarte di ram esponude incerade",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statue di golem di ram esponude incerade",
  "block.minecraft.waxed_exposed_copper_grate": "Grade di ram esponude incerade",
  "block.minecraft.waxed_exposed_copper_lantern": "Ferâl di ram esponût incerât",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trabuchel di ram esponût incerât",
  "block.minecraft.waxed_exposed_cut_copper": "Ram intaiât esponût incerât",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lastre di ram intaiât esponût incerât",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Scjalins di ram intaiât esponût incerât",
  "block.minecraft.waxed_exposed_lightning_rod": "Paresaetis esponût incerât",
  "block.minecraft.waxed_lightning_rod": "Paresaetis incerât",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ram ceselât ossidât incerât",
  "block.minecraft.waxed_oxidized_copper": "Ram ossidât incerât",
  "block.minecraft.waxed_oxidized_copper_bars": "Sbaris di ram ossidadis inceradis",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampade di ram ossidade incerade",
  "block.minecraft.waxed_oxidized_copper_chain": "Cjadene di ram ossidade incerade",
  "block.minecraft.waxed_oxidized_copper_chest": "Baûl di ram ossidât incerât",
  "block.minecraft.waxed_oxidized_copper_door": "Puarte di ram ossidade incerade",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statue di golem di ram ossidade incerade",
  "block.minecraft.waxed_oxidized_copper_grate": "Grade di ram ossidade incerade",
  "block.minecraft.waxed_oxidized_copper_lantern": "Ferâl di ram ossidât incerât",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trabuchel di ram ossidât incerât",
  "block.minecraft.waxed_oxidized_cut_copper": "Ram intaiât ossidât incerât",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lastre di ram intaiât ossidât incerât",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Scjalins di ram intaiât ossidât incerât",
  "block.minecraft.waxed_oxidized_lightning_rod": "Paresaetis ossidât incerât",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ram ceselât corot incerât",
  "block.minecraft.waxed_weathered_copper": "Ram corot incerât",
  "block.minecraft.waxed_weathered_copper_bars": "Sbaris di ram corotis inceradis",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampade di ram corote incerade",
  "block.minecraft.waxed_weathered_copper_chain": "Cjadene di ram corote incerade",
  "block.minecraft.waxed_weathered_copper_chest": "Baûl di ram corot incerât",
  "block.minecraft.waxed_weathered_copper_door": "Puarte di ram corote incerade",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statue di golem di ram corote incerade",
  "block.minecraft.waxed_weathered_copper_grate": "Grade di ram corote incerade",
  "block.minecraft.waxed_weathered_copper_lantern": "Ferâl di ram corot incerât",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trabuchel di ram corot incerât",
  "block.minecraft.waxed_weathered_cut_copper": "Ram intaiât corot incerât",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lastre di ram intaiât corot incerât",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Scjalins di ram intaiât corot incerât",
  "block.minecraft.waxed_weathered_lightning_rod": "Paresaetis corot incerât",
  "block.minecraft.weathered_chiseled_copper": "Ram ceselât corot",
  "block.minecraft.weathered_copper": "Ram corot",
  "block.minecraft.weathered_copper_bars": "Sbaris di ram corotis",
  "block.minecraft.weathered_copper_bulb": "Lampade di ram corote",
  "block.minecraft.weathered_copper_chain": "Cjadene di ram corote",
  "block.minecraft.weathered_copper_chest": "Baûl di ram corot",
  "block.minecraft.weathered_copper_door": "Puarte di ram corote",
  "block.minecraft.weathered_copper_golem_statue": "Statue di golem di ram corote",
  "block.minecraft.weathered_copper_grate": "Grade di ram corote",
  "block.minecraft.weathered_copper_lantern": "Ferâl di ram corot",
  "block.minecraft.weathered_copper_trapdoor": "Trabuchel di ram corot",
  "block.minecraft.weathered_cut_copper": "Ram intaiât corot",
  "block.minecraft.weathered_cut_copper_slab": "Lastre di ram intaiât corot",
  "block.minecraft.weathered_cut_copper_stairs": "Scjalins di ram intaiât corot",
  "block.minecraft.weathered_lightning_rod": "Paresaetis corot",
  "block.minecraft.weeping_vines": "Rampighins vaiulints",
  "block.minecraft.weeping_vines_plant": "Plante rampighine vaiulinte",
  "block.minecraft.wet_sponge": "Sponze bagnade",
  "block.minecraft.wheat": "Forment",
  "block.minecraft.white_banner": "Stendart blanc",
  "block.minecraft.white_bed": "Jet blanc",
  "block.minecraft.white_candle": "Cjandele blancje",
  "block.minecraft.white_candle_cake": "Torte cun cjandele blancje",
  "block.minecraft.white_carpet": "Tapêt blanc",
  "block.minecraft.white_concrete": "Beton blanc",
  "block.minecraft.white_concrete_powder": "Beton blanc in polvar",
  "block.minecraft.white_glazed_terracotta": "Crep dât di smalt blanc",
  "block.minecraft.white_shulker_box": "Scjatule di shulker blancje",
  "block.minecraft.white_stained_glass": "Veri colorât di blanc",
  "block.minecraft.white_stained_glass_pane": "Panel di veri colôr blanc",
  "block.minecraft.white_terracotta": "Crep blanc",
  "block.minecraft.white_tulip": "Tulipan blanc",
  "block.minecraft.white_wool": "Lane blancje",
  "block.minecraft.wildflowers": "Rosis salvadis",
  "block.minecraft.wither_rose": "Rose di Wither",
  "block.minecraft.wither_skeleton_skull": "Crani di scheletri wither",
  "block.minecraft.wither_skeleton_wall_skull": "Crani di scheletri wither a mûr",
  "block.minecraft.yellow_banner": "Stendart zâl",
  "block.minecraft.yellow_bed": "Jet zâl",
  "block.minecraft.yellow_candle": "Cjandele zale",
  "block.minecraft.yellow_candle_cake": "Torte cun cjandele zale",
  "block.minecraft.yellow_carpet": "Tapêt zâl",
  "block.minecraft.yellow_concrete": "Beton zâl",
  "block.minecraft.yellow_concrete_powder": "Beton zâl in polvar",
  "block.minecraft.yellow_glazed_terracotta": "Crep dât di smalt zâl",
  "block.minecraft.yellow_shulker_box": "Scjatule di shulker zale",
  "block.minecraft.yellow_stained_glass": "Veri colorât di zâl",
  "block.minecraft.yellow_stained_glass_pane": "Panel di veri colôr zâl",
  "block.minecraft.yellow_terracotta": "Crep zâl",
  "block.minecraft.yellow_wool": "Lane zale",
  "block.minecraft.zombie_head": "Cjâf di zombi",
  "block.minecraft.zombie_wall_head": "Cjâf di zombi a mûr",
  "item.minecraft.acacia_boat": "Barcje di agacie",
  "item.minecraft.acacia_chest_boat": "Barcje di agacie cun baûl",
  "item.minecraft.allay_spawn_egg": "Ûf di nassite dal slizeridôr",
  "item.minecraft.amethyst_shard": "Sclese di ametiste",
  "item.minecraft.angler_pottery_shard": "Crep cun cjane di pescje",
  "item.minecraft.angler_pottery_sherd": "Crep cun cjane di pescje",
  "item.minecraft.apple": "Miluç",
  "item.minecraft.archer_pottery_shard": "Crep cun arc e frece",
  "item.minecraft.archer_pottery_sherd": "Crep cun arc e frece",
  "item.minecraft.armadillo_scute": "Scus di armadil",
  "item.minecraft.armadillo_spawn_egg": "Ûf di nassite dal armadil",
  "item.minecraft.armor_stand": "Picjot",
  "item.minecraft.arms_up_pottery_shard": "Crep cun alçade di braçs",
  "item.minecraft.arms_up_pottery_sherd": "Crep cun alçade di braçs",
  "item.minecraft.arrow": "Frece",
  "item.minecraft.axolotl_bucket": "Seglot cun axolotl",
  "item.minecraft.axolotl_spawn_egg": "Ûf di nassite dal axolotl",
  "item.minecraft.baked_potato": "Patate rustide",
  "item.minecraft.bamboo_chest_raft": "Çate di bambù cun baûl",
  "item.minecraft.bamboo_raft": "Çate di bambù",
  "item.minecraft.bat_spawn_egg": "Ûf di nassite dal gnotul",
  "item.minecraft.bee_spawn_egg": "Ûf di nassite de âf",
  "item.minecraft.beef": "Cjar di manç crude",
  "item.minecraft.beetroot": "Jerbe rave",
  "item.minecraft.beetroot_seeds": "Semencis di jerbe rave",
  "item.minecraft.beetroot_soup": "Sope di jerbe rave",
  "item.minecraft.birch_boat": "Barcje di bedoi",
  "item.minecraft.birch_chest_boat": "Barcje di bedoi cun baûl",
  "item.minecraft.black_bundle": "Sacut neri",
  "item.minecraft.black_dye": "Tinture nere",
  "item.minecraft.black_harness": "Imbragadure nere",
  "item.minecraft.blade_pottery_shard": "Crep cun lame",
  "item.minecraft.blade_pottery_sherd": "Crep cun lame",
  "item.minecraft.blaze_powder": "Polvar di flamade",
  "item.minecraft.blaze_rod": "Vuiscje di flamade",
  "item.minecraft.blaze_spawn_egg": "Ûf di nassite de flamade",
  "item.minecraft.blue_bundle": "Sacut blu",
  "item.minecraft.blue_dye": "Tinture blu",
  "item.minecraft.blue_egg": "Ûf blu",
  "item.minecraft.blue_harness": "Imbragadure blu",
  "item.minecraft.bogged_spawn_egg": "Ûf di nassite dal paludan",
  "item.minecraft.bolt_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornament cun stîl bulon",
  "item.minecraft.bone": "Vues",
  "item.minecraft.bone_meal": "Farine di vues",
  "item.minecraft.book": "Libri",
  "item.minecraft.bordure_indented_banner_pattern": "Model di stendart cun bordure dintade",
  "item.minecraft.bow": "Arc",
  "item.minecraft.bowl": "Scudiele",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Vuiscje di brise",
  "item.minecraft.breeze_spawn_egg": "Ûf di nassite de brise",
  "item.minecraft.brewer_pottery_shard": "Crep cun ampole",
  "item.minecraft.brewer_pottery_sherd": "Crep cun ampole",
  "item.minecraft.brewing_stand": "Lambic",
  "item.minecraft.brick": "Modon",
  "item.minecraft.brown_bundle": "Sacut maron",
  "item.minecraft.brown_dye": "Tinture maron",
  "item.minecraft.brown_egg": "Ûf maron",
  "item.minecraft.brown_harness": "Imbragadure maron",
  "item.minecraft.brush": "Sborfin",
  "item.minecraft.bucket": "Seglot",
  "item.minecraft.bundle": "Sacut",
  "item.minecraft.bundle.empty": "Vueit",
  "item.minecraft.bundle.empty.description": "Al pues tignî une pile messedade di ogjets",
  "item.minecraft.bundle.full": "Plen",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Crep cun flame",
  "item.minecraft.burn_pottery_sherd": "Crep cun flame",
  "item.minecraft.camel_husk_spawn_egg": "Ûf di nassite dal dromedari sec",
  "item.minecraft.camel_spawn_egg": "Ûf di nassite dal dromedari",
  "item.minecraft.carrot": "Carote",
  "item.minecraft.carrot_on_a_stick": "Baston cu la carote",
  "item.minecraft.cat_spawn_egg": "Ûf di nassite dal gjat",
  "item.minecraft.cauldron": "Cjalderon",
  "item.minecraft.cave_spider_spawn_egg": "Ûf di nassite dal ragn dai landris",
  "item.minecraft.chainmail_boots": "Stivâi in maie di fier",
  "item.minecraft.chainmail_chestplate": "Usberc in maie di fier",
  "item.minecraft.chainmail_helmet": "Elm in maie di fier",
  "item.minecraft.chainmail_leggings": "Braghesse in maie di fier",
  "item.minecraft.charcoal": "Carbonele",
  "item.minecraft.cherry_boat": "Barcje di cjariesâr",
  "item.minecraft.cherry_chest_boat": "Barcje di cjariesâr cun baûl",
  "item.minecraft.chest_minecart": "Carel minerari cun baûl",
  "item.minecraft.chicken": "Poleç crût",
  "item.minecraft.chicken_spawn_egg": "Ûf di nassite dal poleç",
  "item.minecraft.chorus_fruit": "Pome corâl",
  "item.minecraft.clay_ball": "Bale di arzile",
  "item.minecraft.clock": "Orloi",
  "item.minecraft.coal": "Cjarbon",
  "item.minecraft.coast_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornament cun stîl costîr",
  "item.minecraft.cocoa_beans": "Favis di cacau",
  "item.minecraft.cod": "Merluç crût",
  "item.minecraft.cod_bucket": "Seglot cun merluç",
  "item.minecraft.cod_spawn_egg": "Ûf di nassite dal merluç",
  "item.minecraft.command_block_minecart": "Carel minerari cun bloc comants",
  "item.minecraft.compass": "Bussule",
  "item.minecraft.cooked_beef": "Bisteche",
  "item.minecraft.cooked_chicken": "Poleç cuet",
  "item.minecraft.cooked_cod": "Merluç cuet",
  "item.minecraft.cooked_mutton": "Cjar di piore cuete",
  "item.minecraft.cooked_porkchop": "Brusadule di purcit cuete",
  "item.minecraft.cooked_rabbit": "Cjar di cunin cuete",
  "item.minecraft.cooked_salmon": "Salmon cuet",
  "item.minecraft.cookie": "Biscot",
  "item.minecraft.copper_axe": "Manarie di ram",
  "item.minecraft.copper_boots": "Stivâi di ram",
  "item.minecraft.copper_chestplate": "Corace di ram",
  "item.minecraft.copper_golem_spawn_egg": "Ûf di nassite dal golem di ram",
  "item.minecraft.copper_helmet": "Elm di ram",
  "item.minecraft.copper_hoe": "Sape di ram",
  "item.minecraft.copper_horse_armor": "Furniment in ram pal cjaval",
  "item.minecraft.copper_ingot": "Lingot di ram",
  "item.minecraft.copper_leggings": "Gjambâi in ram",
  "item.minecraft.copper_nautilus_armor": "Armadure in ram pal nautil",
  "item.minecraft.copper_nugget": "Pepite di ram",
  "item.minecraft.copper_pickaxe": "Picon di ram",
  "item.minecraft.copper_shovel": "Pale di ram",
  "item.minecraft.copper_spear": "Lance di ram",
  "item.minecraft.copper_sword": "Spade di ram",
  "item.minecraft.cow_spawn_egg": "Ûf di nassite de vacje",
  "item.minecraft.creaking_spawn_egg": "Ûf di nassite dal cric",
  "item.minecraft.creeper_banner_pattern": "Model di stendart",
  "item.minecraft.creeper_banner_pattern.desc": "Muse di creeper",
  "item.minecraft.creeper_banner_pattern.new": "Model di stendart cun muse di creeper",
  "item.minecraft.creeper_spawn_egg": "Ûf di nassite dal creeper",
  "item.minecraft.crossbow": "Balestre",
  "item.minecraft.crossbow.projectile": "Proietil:",
  "item.minecraft.crossbow.projectile.multiple": "Proietil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proietil: %s",
  "item.minecraft.cyan_bundle": "Sacut ciano",
  "item.minecraft.cyan_dye": "Tinture ciano",
  "item.minecraft.cyan_harness": "Imbragadure ciano",
  "item.minecraft.danger_pottery_shard": "Crep cun avertiment",
  "item.minecraft.danger_pottery_sherd": "Crep cun avertiment",
  "item.minecraft.dark_oak_boat": "Barcje di rôl scûr",
  "item.minecraft.dark_oak_chest_boat": "Barcje di rôl scûr cun baûl",
  "item.minecraft.debug_stick": "Stec pal debug",
  "item.minecraft.debug_stick.empty": "%s nol à proprietâts",
  "item.minecraft.debug_stick.select": "selezionât \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" a %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Manarie di diamant",
  "item.minecraft.diamond_boots": "Stivâi di diamant",
  "item.minecraft.diamond_chestplate": "Corace di diamant",
  "item.minecraft.diamond_helmet": "Elm di diamant",
  "item.minecraft.diamond_hoe": "Sape di diamant",
  "item.minecraft.diamond_horse_armor": "Furniment in diamant pal cjaval",
  "item.minecraft.diamond_leggings": "Gjambâi di diamant",
  "item.minecraft.diamond_nautilus_armor": "Armadure in diamant pal nautil",
  "item.minecraft.diamond_pickaxe": "Picon di diamant",
  "item.minecraft.diamond_shovel": "Pale di diamant",
  "item.minecraft.diamond_spear": "Lance di diamant",
  "item.minecraft.diamond_sword": "Spade di diamant",
  "item.minecraft.disc_fragment_5": "Toc di disc",
  "item.minecraft.disc_fragment_5.desc": "Disc musicâl - 5",
  "item.minecraft.dolphin_spawn_egg": "Ûf di nassite dal dolfin",
  "item.minecraft.donkey_spawn_egg": "Ûf di nassite dal mus",
  "item.minecraft.dragon_breath": "Flât di drâc",
  "item.minecraft.dried_kelp": "Alighe secjade",
  "item.minecraft.drowned_spawn_egg": "Ûf di nassite dal inneât",
  "item.minecraft.dune_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornament cun stîl dune",
  "item.minecraft.echo_shard": "Sclese di risonance",
  "item.minecraft.egg": "Ûf",
  "item.minecraft.elder_guardian_spawn_egg": "Ûf di nassite dal vuardian veteran",
  "item.minecraft.elytra": "Elitris",
  "item.minecraft.emerald": "Smeralt",
  "item.minecraft.enchanted_book": "Libri incjantât",
  "item.minecraft.enchanted_golden_apple": "Miluç di aur incjantât",
  "item.minecraft.end_crystal": "Cristal dal End",
  "item.minecraft.ender_dragon_spawn_egg": "Ûf di nassite dal drâc dal End",
  "item.minecraft.ender_eye": "Voli dal Ender",
  "item.minecraft.ender_pearl": "Perle dal End",
  "item.minecraft.enderman_spawn_egg": "Ûf di nassite dal enderman",
  "item.minecraft.endermite_spawn_egg": "Ûf di nassite dal endermite",
  "item.minecraft.evoker_spawn_egg": "Ûf di nassite dal evocadôr",
  "item.minecraft.experience_bottle": "Pozion di esperience",
  "item.minecraft.explorer_pottery_shard": "Crep cun mape",
  "item.minecraft.explorer_pottery_sherd": "Crep cun mape",
  "item.minecraft.eye_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornament cun stîl voli",
  "item.minecraft.feather": "Plume",
  "item.minecraft.fermented_spider_eye": "Voli di ragn fermentât",
  "item.minecraft.field_masoned_banner_pattern": "Model di stendart cun semenât di modons",
  "item.minecraft.filled_map": "Mape",
  "item.minecraft.fire_charge": "Cjarie di fûc",
  "item.minecraft.firework_rocket": "Fusete",
  "item.minecraft.firework_rocket.flight": "Durade dal svol:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Stele de fusete",
  "item.minecraft.firework_star.black": "Nere",
  "item.minecraft.firework_star.blue": "Blu",
  "item.minecraft.firework_star.brown": "Maron",
  "item.minecraft.firework_star.custom_color": "Personalizade",
  "item.minecraft.firework_star.cyan": "Ciano",
  "item.minecraft.firework_star.fade_to": "Sfante su",
  "item.minecraft.firework_star.flicker": "Slusicament",
  "item.minecraft.firework_star.gray": "Grise",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Blu clâr",
  "item.minecraft.firework_star.light_gray": "Grîs clâr",
  "item.minecraft.firework_star.lime": "Vert limon",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Naranç",
  "item.minecraft.firework_star.pink": "Rose",
  "item.minecraft.firework_star.purple": "Viole",
  "item.minecraft.firework_star.red": "Rosse",
  "item.minecraft.firework_star.shape": "Forme no cognossude",
  "item.minecraft.firework_star.shape.burst": "A sclop",
  "item.minecraft.firework_star.shape.creeper": "A forme di creeper",
  "item.minecraft.firework_star.shape.large_ball": "Sfere grande",
  "item.minecraft.firework_star.shape.small_ball": "Sfere piçule",
  "item.minecraft.firework_star.shape.star": "A forme di stele",
  "item.minecraft.firework_star.trail": "Code",
  "item.minecraft.firework_star.white": "Blancje",
  "item.minecraft.firework_star.yellow": "Zale",
  "item.minecraft.fishing_rod": "Cjane di pescje",
  "item.minecraft.flint": "Siliç",
  "item.minecraft.flint_and_steel": "Açalin",
  "item.minecraft.flow_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornament cun stîl flus",
  "item.minecraft.flow_banner_pattern": "Model di stendart",
  "item.minecraft.flow_banner_pattern.desc": "Flus",
  "item.minecraft.flow_banner_pattern.new": "Model di stendart cun flus",
  "item.minecraft.flow_pottery_sherd": "Crep cun flus",
  "item.minecraft.flower_banner_pattern": "Model di stendart",
  "item.minecraft.flower_banner_pattern.desc": "Rose",
  "item.minecraft.flower_banner_pattern.new": "Model di stendart cun rose",
  "item.minecraft.flower_pot": "Vâs par rosis",
  "item.minecraft.fox_spawn_egg": "Ûf di nassite de bolp",
  "item.minecraft.friend_pottery_shard": "Crep cun amì",
  "item.minecraft.friend_pottery_sherd": "Crep cun amì",
  "item.minecraft.frog_spawn_egg": "Ûf di nassite dal crot",
  "item.minecraft.furnace_minecart": "Carel minerari cun fornâs",
  "item.minecraft.ghast_spawn_egg": "Ûf di nassite dal ghast",
  "item.minecraft.ghast_tear": "Lagrime di ghast",
  "item.minecraft.glass_bottle": "Butilie",
  "item.minecraft.glistering_melon_slice": "Fete sflandorose di angurie",
  "item.minecraft.globe_banner_pattern": "Model di stendart",
  "item.minecraft.globe_banner_pattern.desc": "Globi",
  "item.minecraft.globe_banner_pattern.new": "Model di stendart cun globi",
  "item.minecraft.glow_berries": "Pomulis luminessentis",
  "item.minecraft.glow_ink_sac": "Sache di ingjustri luminessent",
  "item.minecraft.glow_item_frame": "Curnîs luminessente",
  "item.minecraft.glow_squid_spawn_egg": "Ûf di nassite dal calamâr luminessent",
  "item.minecraft.glowstone_dust": "Polvar di piere luminose",
  "item.minecraft.goat_horn": "Cuar di cjavre",
  "item.minecraft.goat_spawn_egg": "Ûf di nassite de cjavre",
  "item.minecraft.gold_ingot": "Lingot di aur",
  "item.minecraft.gold_nugget": "Pepite di aur",
  "item.minecraft.golden_apple": "Miluç di aur",
  "item.minecraft.golden_axe": "Manarie di aur",
  "item.minecraft.golden_boots": "Stivâi in aur",
  "item.minecraft.golden_carrot": "Carote dorade",
  "item.minecraft.golden_chestplate": "Corace in aur",
  "item.minecraft.golden_helmet": "Elm in aur",
  "item.minecraft.golden_hoe": "Sape di aur",
  "item.minecraft.golden_horse_armor": "Furniment in aur pal cjaval",
  "item.minecraft.golden_leggings": "Gjambâi in aur",
  "item.minecraft.golden_nautilus_armor": "Armadure in aur pal nautil",
  "item.minecraft.golden_pickaxe": "Picon di aur",
  "item.minecraft.golden_shovel": "Pale di aur",
  "item.minecraft.golden_spear": "Lance di aur",
  "item.minecraft.golden_sword": "Spade di aur",
  "item.minecraft.gray_bundle": "Sacut grîs",
  "item.minecraft.gray_dye": "Tinture grise",
  "item.minecraft.gray_harness": "Imbragadure grise",
  "item.minecraft.green_bundle": "Sacut vert",
  "item.minecraft.green_dye": "Tinture verde",
  "item.minecraft.green_harness": "Imbragadure verde",
  "item.minecraft.guardian_spawn_egg": "Ûf di nassite dal vuardian",
  "item.minecraft.gunpowder": "Polvar di sclope",
  "item.minecraft.guster_banner_pattern": "Model di stendart",
  "item.minecraft.guster_banner_pattern.desc": "Bugade",
  "item.minecraft.guster_banner_pattern.new": "Model di stendart cun bugade",
  "item.minecraft.guster_pottery_sherd": "Crep cun bugade",
  "item.minecraft.happy_ghast_spawn_egg": "Ûf di nassite dal Ghast legri",
  "item.minecraft.harness": "Imbragadure",
  "item.minecraft.heart_of_the_sea": "Cûr dal mâr",
  "item.minecraft.heart_pottery_shard": "Crep cun cûr",
  "item.minecraft.heart_pottery_sherd": "Crep cun cûr",
  "item.minecraft.heartbreak_pottery_shard": "Crep cun cûr rot",
  "item.minecraft.heartbreak_pottery_sherd": "Crep cun cûr rot",
  "item.minecraft.hoglin_spawn_egg": "Ûf di nassite dal hoglin",
  "item.minecraft.honey_bottle": "Butilie di mîl",
  "item.minecraft.honeycomb": "Celet",
  "item.minecraft.hopper_minecart": "Carel minerari cun tramuele",
  "item.minecraft.horse_spawn_egg": "Ûf di nassite dal cjaval",
  "item.minecraft.host_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornament cun stîl ospit",
  "item.minecraft.howl_pottery_shard": "Crep cun lôf",
  "item.minecraft.howl_pottery_sherd": "Crep cun lôf",
  "item.minecraft.husk_spawn_egg": "Ûf di nassite dal zombi sec",
  "item.minecraft.ink_sac": "Sache di ingjustri",
  "item.minecraft.iron_axe": "Manarie di fier",
  "item.minecraft.iron_boots": "Stivâi di fier",
  "item.minecraft.iron_chestplate": "Corace di fier",
  "item.minecraft.iron_golem_spawn_egg": "Ûf di nassite dal golem di fier",
  "item.minecraft.iron_helmet": "Elm di fier",
  "item.minecraft.iron_hoe": "Sape di fier",
  "item.minecraft.iron_horse_armor": "Furniment in fier pal cjaval",
  "item.minecraft.iron_ingot": "Lingot di fier",
  "item.minecraft.iron_leggings": "Gjambâi di fier",
  "item.minecraft.iron_nautilus_armor": "Armadure in fier pal nautil",
  "item.minecraft.iron_nugget": "Pepite di fier",
  "item.minecraft.iron_pickaxe": "Picon di fier",
  "item.minecraft.iron_shovel": "Pale di fier",
  "item.minecraft.iron_spear": "Lance di fier",
  "item.minecraft.iron_sword": "Spade di fier",
  "item.minecraft.item_frame": "Curnîs",
  "item.minecraft.jungle_boat": "Barcje di len di jungle",
  "item.minecraft.jungle_chest_boat": "Barcje di len di jungle cun baûl",
  "item.minecraft.knowledge_book": "Libri dal savê",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Seglot di lave",
  "item.minecraft.lead": "Sguinçâl",
  "item.minecraft.leather": "Corean",
  "item.minecraft.leather_boots": "Stivâi di corean",
  "item.minecraft.leather_chestplate": "Gjubot di corean",
  "item.minecraft.leather_helmet": "Casc di corean",
  "item.minecraft.leather_horse_armor": "Furniment in corean pal cjaval",
  "item.minecraft.leather_leggings": "Bregons di corean",
  "item.minecraft.light_blue_bundle": "Sacut blu clâr",
  "item.minecraft.light_blue_dye": "Tinture blu clâr",
  "item.minecraft.light_blue_harness": "Imbragadure blu clâr",
  "item.minecraft.light_gray_bundle": "Sacut grîs clâr",
  "item.minecraft.light_gray_dye": "Tinture grîs clâr",
  "item.minecraft.light_gray_harness": "Imbragadure grîs clâr",
  "item.minecraft.lime_bundle": "Sacut vert limon",
  "item.minecraft.lime_dye": "Tinture vert limon",
  "item.minecraft.lime_harness": "Imbragadure vert limon",
  "item.minecraft.lingering_potion": "Pozion persistente",
  "item.minecraft.lingering_potion.effect.awkward": "Pozion strane persistente",
  "item.minecraft.lingering_potion.effect.empty": "Pozion persistente no fabricabile",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Pozion di resistence al fûc persistente",
  "item.minecraft.lingering_potion.effect.harming": "Pozion di dam persistente",
  "item.minecraft.lingering_potion.effect.healing": "Pozion di cure persistente",
  "item.minecraft.lingering_potion.effect.infested": "Pozion di infestazion persistente",
  "item.minecraft.lingering_potion.effect.invisibility": "Pozion di invisibilitât persistente",
  "item.minecraft.lingering_potion.effect.leaping": "Pozion di salt persistente",
  "item.minecraft.lingering_potion.effect.levitation": "Pozion di levitazion persistente",
  "item.minecraft.lingering_potion.effect.luck": "Pozion di fortune persistente",
  "item.minecraft.lingering_potion.effect.mundane": "Pozion ordenarie persistente",
  "item.minecraft.lingering_potion.effect.night_vision": "Pozion di vision noturne persistente",
  "item.minecraft.lingering_potion.effect.oozing": "Pozion di secrezion persistente",
  "item.minecraft.lingering_potion.effect.poison": "Pozion di invelenament persistente",
  "item.minecraft.lingering_potion.effect.regeneration": "Pozion di rigjenerazion persistente",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pozion persistente pal colâ planc",
  "item.minecraft.lingering_potion.effect.slowness": "Pozion di lentece persistente",
  "item.minecraft.lingering_potion.effect.strength": "Pozion di fuarce persistente",
  "item.minecraft.lingering_potion.effect.swiftness": "Pozion di rapiditât persistente",
  "item.minecraft.lingering_potion.effect.thick": "Pozion penze persistente",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pozion dal mestri copasse persistente",
  "item.minecraft.lingering_potion.effect.water": "Boce di aghe persistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pozion di respîr te aghe persistente",
  "item.minecraft.lingering_potion.effect.weakness": "Pozion di debilece persistente",
  "item.minecraft.lingering_potion.effect.weaving": "Pozion di tiessidure persistente",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pozion di cjarie di aiar persistente",
  "item.minecraft.llama_spawn_egg": "Ûf di nassite dal lama",
  "item.minecraft.lodestone_compass": "Bussule magnetizade",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Sacut magenta",
  "item.minecraft.magenta_dye": "Tinture magenta",
  "item.minecraft.magenta_harness": "Imbragadure magenta",
  "item.minecraft.magma_cream": "Creme di magme",
  "item.minecraft.magma_cube_spawn_egg": "Ûf di nassite dal cubi di magme",
  "item.minecraft.mangrove_boat": "Barcje di mangrovie",
  "item.minecraft.mangrove_chest_boat": "Barcje di mangrovie cun baûl",
  "item.minecraft.map": "Mape vueide",
  "item.minecraft.melon_seeds": "Semencis di angurie",
  "item.minecraft.melon_slice": "Fete di angurie",
  "item.minecraft.milk_bucket": "Seglot di lat",
  "item.minecraft.minecart": "Carel minerari",
  "item.minecraft.miner_pottery_shard": "Crep cun picon",
  "item.minecraft.miner_pottery_sherd": "Crep cun picon",
  "item.minecraft.mojang_banner_pattern": "Model di stendart",
  "item.minecraft.mojang_banner_pattern.desc": "Logo",
  "item.minecraft.mojang_banner_pattern.new": "Model di stendart cun logo",
  "item.minecraft.mooshroom_spawn_egg": "Ûf di nassite di mooshroom",
  "item.minecraft.mourner_pottery_shard": "Crep cun corot",
  "item.minecraft.mourner_pottery_sherd": "Crep cun corot",
  "item.minecraft.mule_spawn_egg": "Ûf di nassite dal mûl",
  "item.minecraft.mushroom_stew": "Sope di foncs",
  "item.minecraft.music_disc_11": "Disc musicâl",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disc musicâl",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disc musicâl",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disc musicâl",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disc musicâl",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disc musicâl",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disc musicâl",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disc musicâl",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (carillon)",
  "item.minecraft.music_disc_far": "Disc musicâl",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disc musicâl",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disc musicâl",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disc musicâl",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disc musicâl",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disc musicâl",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disc musicâl",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disc musicâl",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disc musicâl",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disc musicâl",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disc musicâl",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disc musicâl",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disc musicâl",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cjar di piore crude",
  "item.minecraft.name_tag": "Etichete pal non",
  "item.minecraft.nautilus_shell": "Cape di nautil",
  "item.minecraft.nautilus_spawn_egg": "Ûf di nassite dal nautil",
  "item.minecraft.nether_brick": "Modon dal Nether",
  "item.minecraft.nether_star": "Stele dal Nether",
  "item.minecraft.nether_wart": "Riçûl dal Nether",
  "item.minecraft.netherite_axe": "Manarie in netherite",
  "item.minecraft.netherite_boots": "Stivâi in netherite",
  "item.minecraft.netherite_chestplate": "Corace in netherite",
  "item.minecraft.netherite_helmet": "Elm in netherite",
  "item.minecraft.netherite_hoe": "Sape in netherite",
  "item.minecraft.netherite_horse_armor": "Furniment in netherite pal cjaval",
  "item.minecraft.netherite_ingot": "Lingot di netherite",
  "item.minecraft.netherite_leggings": "Gjambâi in netherite",
  "item.minecraft.netherite_nautilus_armor": "Armadure in netherite pal nautil",
  "item.minecraft.netherite_pickaxe": "Picon in netherite",
  "item.minecraft.netherite_scrap": "Rotum di netherite",
  "item.minecraft.netherite_shovel": "Pale in netherite",
  "item.minecraft.netherite_spear": "Lance di netherite",
  "item.minecraft.netherite_sword": "Spade in netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Model par fari",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Miorament di netherite",
  "item.minecraft.oak_boat": "Barcje di rôl",
  "item.minecraft.oak_chest_boat": "Barcje di rôl cun baûl",
  "item.minecraft.ocelot_spawn_egg": "Ûf di nassite dal gjat salvadi",
  "item.minecraft.ominous_bottle": "Boce dal malauguri",
  "item.minecraft.ominous_trial_key": "Clâf de prove dal malauguri",
  "item.minecraft.orange_bundle": "Sacut naranç",
  "item.minecraft.orange_dye": "Tinture naranç",
  "item.minecraft.orange_harness": "Imbragadure naranç",
  "item.minecraft.painting": "Cuadri",
  "item.minecraft.pale_oak_boat": "Barcje di rôl palit",
  "item.minecraft.pale_oak_chest_boat": "Barcje di rôl palit cun baûl",
  "item.minecraft.panda_spawn_egg": "Ûf di nassite dal panda",
  "item.minecraft.paper": "Cjarte",
  "item.minecraft.parched_spawn_egg": "Ûf di nassite dal secjât",
  "item.minecraft.parrot_spawn_egg": "Ûf di nassite dal pampagal",
  "item.minecraft.phantom_membrane": "Membrane di fantasime",
  "item.minecraft.phantom_spawn_egg": "Ûf di nassite de fantasime",
  "item.minecraft.pig_spawn_egg": "Ûf di nassite dal purcit",
  "item.minecraft.piglin_banner_pattern": "Model di stendart",
  "item.minecraft.piglin_banner_pattern.desc": "Music",
  "item.minecraft.piglin_banner_pattern.new": "Model di stendart cun music",
  "item.minecraft.piglin_brute_spawn_egg": "Ûf di nassite dal piglin brutâl",
  "item.minecraft.piglin_spawn_egg": "Ûf di nassite dal piglin",
  "item.minecraft.pillager_spawn_egg": "Ûf di nassite dal sachizadôr",
  "item.minecraft.pink_bundle": "Sacut rose",
  "item.minecraft.pink_dye": "Tinture rose",
  "item.minecraft.pink_harness": "Imbragadure rose",
  "item.minecraft.pitcher_plant": "Plante bocâl",
  "item.minecraft.pitcher_pod": "Cosul di plante bocâl",
  "item.minecraft.plenty_pottery_shard": "Crep cun ricjecis",
  "item.minecraft.plenty_pottery_sherd": "Crep cun ricjecis",
  "item.minecraft.poisonous_potato": "Patate velenose",
  "item.minecraft.polar_bear_spawn_egg": "Ûf di nassite dal ors polâr",
  "item.minecraft.popped_chorus_fruit": "Pome corâl sclopade",
  "item.minecraft.porkchop": "Brusadule di purcit crude",
  "item.minecraft.potato": "Patate",
  "item.minecraft.potion": "Pozion",
  "item.minecraft.potion.effect.awkward": "Pozion strane",
  "item.minecraft.potion.effect.empty": "Pozion no fabricabile",
  "item.minecraft.potion.effect.fire_resistance": "Pozion di resistence al fûc",
  "item.minecraft.potion.effect.harming": "Pozion di dam",
  "item.minecraft.potion.effect.healing": "Pozion di cure",
  "item.minecraft.potion.effect.infested": "Pozion di infestazion",
  "item.minecraft.potion.effect.invisibility": "Pozion di invisibilitât",
  "item.minecraft.potion.effect.leaping": "Pozion di salt",
  "item.minecraft.potion.effect.levitation": "Pozion di levitazion",
  "item.minecraft.potion.effect.luck": "Pozion di fortune",
  "item.minecraft.potion.effect.mundane": "Pozion ordenarie",
  "item.minecraft.potion.effect.night_vision": "Pozion de vision noturne",
  "item.minecraft.potion.effect.oozing": "Pozion di secrezion",
  "item.minecraft.potion.effect.poison": "Pozion di invelenament",
  "item.minecraft.potion.effect.regeneration": "Pozion di rigjenerazion",
  "item.minecraft.potion.effect.slow_falling": "Pozion dal colâ planc",
  "item.minecraft.potion.effect.slowness": "Pozion di lentece",
  "item.minecraft.potion.effect.strength": "Pozion di fuarce",
  "item.minecraft.potion.effect.swiftness": "Pozion di rapiditât",
  "item.minecraft.potion.effect.thick": "Pozion penze",
  "item.minecraft.potion.effect.turtle_master": "Pozion dal mestri copasse",
  "item.minecraft.potion.effect.water": "Boce di aghe",
  "item.minecraft.potion.effect.water_breathing": "Pozion di respîr te aghe",
  "item.minecraft.potion.effect.weakness": "Pozion di debilece",
  "item.minecraft.potion.effect.weaving": "Pozion di tiessidure",
  "item.minecraft.potion.effect.wind_charged": "Pozion di cjarie di aiar",
  "item.minecraft.pottery_shard_archer": "Crep cun arc e frece",
  "item.minecraft.pottery_shard_arms_up": "Crep cun alçade di braçs",
  "item.minecraft.pottery_shard_prize": "Crep cun premi",
  "item.minecraft.pottery_shard_skull": "Crep cun crani",
  "item.minecraft.powder_snow_bucket": "Seglot di nêf farinose",
  "item.minecraft.prismarine_crystals": "Cristai di prismarine",
  "item.minecraft.prismarine_shard": "Toc di prismarine",
  "item.minecraft.prize_pottery_shard": "Crep cun premi",
  "item.minecraft.prize_pottery_sherd": "Crep cun premi",
  "item.minecraft.pufferfish": "Pes-bale",
  "item.minecraft.pufferfish_bucket": "Seglot cun pes-bale",
  "item.minecraft.pufferfish_spawn_egg": "Ûf di nassite dal pes-bale",
  "item.minecraft.pumpkin_pie": "Torte di coce",
  "item.minecraft.pumpkin_seeds": "Semencis di coce",
  "item.minecraft.purple_bundle": "Sacut viole",
  "item.minecraft.purple_dye": "Tinture viole",
  "item.minecraft.purple_harness": "Imbragadure viole",
  "item.minecraft.quartz": "Cuarç dal Nether",
  "item.minecraft.rabbit": "Cjar di cunin crude",
  "item.minecraft.rabbit_foot": "Talpe di cunin",
  "item.minecraft.rabbit_hide": "Piel di cunin",
  "item.minecraft.rabbit_spawn_egg": "Ûf di nassite dal cunin",
  "item.minecraft.rabbit_stew": "Stofât di cunin",
  "item.minecraft.raiser_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornament cun stîl arlevadôr",
  "item.minecraft.ravager_spawn_egg": "Ûf di nassite dal devastadôr",
  "item.minecraft.raw_copper": "Ram grês",
  "item.minecraft.raw_gold": "Aur grês",
  "item.minecraft.raw_iron": "Fier grês",
  "item.minecraft.recovery_compass": "Bussule dal recupar",
  "item.minecraft.red_bundle": "Sacut ros",
  "item.minecraft.red_dye": "Tinture rosse",
  "item.minecraft.red_harness": "Imbragadure rosse",
  "item.minecraft.redstone": "Polvar di redstone",
  "item.minecraft.resin_brick": "Modon di resine",
  "item.minecraft.resin_clump": "Grop di resine",
  "item.minecraft.rib_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornament cun stîl cuestis",
  "item.minecraft.rotten_flesh": "Cjar fraide",
  "item.minecraft.saddle": "Siele",
  "item.minecraft.salmon": "Salmon crût",
  "item.minecraft.salmon_bucket": "Seglot cun salmon",
  "item.minecraft.salmon_spawn_egg": "Ûf di nassite di salmon",
  "item.minecraft.scrape_pottery_sherd": "Crep cun russade",
  "item.minecraft.scute": "Scus",
  "item.minecraft.sentry_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornament cun stîl sentinele",
  "item.minecraft.shaper_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornament cun stîl modeladôr",
  "item.minecraft.sheaf_pottery_shard": "Crep cun mane",
  "item.minecraft.sheaf_pottery_sherd": "Crep cun mane",
  "item.minecraft.shears": "Fuarpiis",
  "item.minecraft.sheep_spawn_egg": "Ûf di nassite de piore",
  "item.minecraft.shelter_pottery_shard": "Crep cun sotet",
  "item.minecraft.shelter_pottery_sherd": "Crep cun sotet",
  "item.minecraft.shield": "Scût",
  "item.minecraft.shield.black": "Scût neri",
  "item.minecraft.shield.blue": "Scût blu",
  "item.minecraft.shield.brown": "Scût maron",
  "item.minecraft.shield.cyan": "Scût ciano",
  "item.minecraft.shield.gray": "Scût grîs",
  "item.minecraft.shield.green": "Scût vert",
  "item.minecraft.shield.light_blue": "Scût blu clâr",
  "item.minecraft.shield.light_gray": "Scût grîs clâr",
  "item.minecraft.shield.lime": "Scût vert limon",
  "item.minecraft.shield.magenta": "Scût magenta",
  "item.minecraft.shield.orange": "Scût naranç",
  "item.minecraft.shield.pink": "Scût rose",
  "item.minecraft.shield.purple": "Scût viole",
  "item.minecraft.shield.red": "Scût ros",
  "item.minecraft.shield.white": "Scût blanc",
  "item.minecraft.shield.yellow": "Scût zâl",
  "item.minecraft.shulker_shell": "Scus dal shulker",
  "item.minecraft.shulker_spawn_egg": "Ûf di nassite dal shulker",
  "item.minecraft.sign": "Cartel",
  "item.minecraft.silence_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornament cun stîl cidin",
  "item.minecraft.silverfish_spawn_egg": "Ûf di nassite dal pessut di arint",
  "item.minecraft.skeleton_horse_spawn_egg": "Ûf di nassite dal cjaval scheletric",
  "item.minecraft.skeleton_spawn_egg": "Ûf di nassite dal scheletri",
  "item.minecraft.skull_banner_pattern": "Model di stendart",
  "item.minecraft.skull_banner_pattern.desc": "Crani",
  "item.minecraft.skull_banner_pattern.new": "Model di stendart cun crani",
  "item.minecraft.skull_pottery_shard": "Crep cun crani",
  "item.minecraft.skull_pottery_sherd": "Crep cun crani",
  "item.minecraft.slime_ball": "Bale di gjeladine",
  "item.minecraft.slime_spawn_egg": "Ûf di nassite de gjeladine",
  "item.minecraft.smithing_template": "Model par fari",
  "item.minecraft.smithing_template.applies_to": "Si apliche a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Zonte un lingot o un cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadure",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Zonte un toc di armadure",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingots e cristai",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Zonte un lingot di netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Furniment di diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Zonte une armadure, arme o imprest di diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingot di netherite",
  "item.minecraft.smithing_template.upgrade": "Miorament: ",
  "item.minecraft.sniffer_spawn_egg": "Ûf di nassite dal nasadôr",
  "item.minecraft.snort_pottery_shard": "Crep cun nasadôr",
  "item.minecraft.snort_pottery_sherd": "Crep cun nasadôr",
  "item.minecraft.snout_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornament cun stîl music",
  "item.minecraft.snow_golem_spawn_egg": "Ûf di nassite dal golem di nêf",
  "item.minecraft.snowball": "Bale di nêf",
  "item.minecraft.spectral_arrow": "Frece spetrâl",
  "item.minecraft.spider_eye": "Voli di ragn",
  "item.minecraft.spider_spawn_egg": "Ûf di nassite dal ragn",
  "item.minecraft.spire_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornament cun stîl spicis",
  "item.minecraft.splash_potion": "Pozion di tîr",
  "item.minecraft.splash_potion.effect.awkward": "Pozion di tîr strane",
  "item.minecraft.splash_potion.effect.empty": "Pozion di tîr no fabricabile",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pozion di tîr pe resistence al fûc",
  "item.minecraft.splash_potion.effect.harming": "Pozion di tîr di dam",
  "item.minecraft.splash_potion.effect.healing": "Pozion di tîr di cure",
  "item.minecraft.splash_potion.effect.infested": "Pozion di tîr di infestazion",
  "item.minecraft.splash_potion.effect.invisibility": "Pozion di tîr pe invisibilitât",
  "item.minecraft.splash_potion.effect.leaping": "Pozion di tîr par saltâ",
  "item.minecraft.splash_potion.effect.levitation": "Pozion di tîr pe levitazion",
  "item.minecraft.splash_potion.effect.luck": "Pozion di tîr pe fortune",
  "item.minecraft.splash_potion.effect.mundane": "Pozion di tîr ordenarie",
  "item.minecraft.splash_potion.effect.night_vision": "Pozion di tîr pe vision noturne",
  "item.minecraft.splash_potion.effect.oozing": "Pozion di tîr di secrezion",
  "item.minecraft.splash_potion.effect.poison": "Pozion di tîr invelenade",
  "item.minecraft.splash_potion.effect.regeneration": "Pozion di tîr pe rigjenerazion",
  "item.minecraft.splash_potion.effect.slow_falling": "Pozion di tîr par colâ planc",
  "item.minecraft.splash_potion.effect.slowness": "Pozion di tîr pe lentece",
  "item.minecraft.splash_potion.effect.strength": "Pozion di tîr pe fuarce",
  "item.minecraft.splash_potion.effect.swiftness": "Pozion di tîr pe rapiditât",
  "item.minecraft.splash_potion.effect.thick": "Pozion di tîr penze",
  "item.minecraft.splash_potion.effect.turtle_master": "Pozion di tîr dal mestri copasse",
  "item.minecraft.splash_potion.effect.water": "Boce di aghe di tirâ",
  "item.minecraft.splash_potion.effect.water_breathing": "Pozion di tîr par respitâ te aghe",
  "item.minecraft.splash_potion.effect.weakness": "Pozion di tîr pe debilece",
  "item.minecraft.splash_potion.effect.weaving": "Pozion di tîr di tiessidure",
  "item.minecraft.splash_potion.effect.wind_charged": "Pozion di tîr di cjarie di aiar",
  "item.minecraft.spruce_boat": "Barcje di peç",
  "item.minecraft.spruce_chest_boat": "Barcje di peç cun baûl",
  "item.minecraft.spyglass": "Canocjâl",
  "item.minecraft.squid_spawn_egg": "Ûf di nassite dal calamâr",
  "item.minecraft.stick": "Stec",
  "item.minecraft.stone_axe": "Manarie di piere",
  "item.minecraft.stone_hoe": "Sape di piere",
  "item.minecraft.stone_pickaxe": "Picon di piere",
  "item.minecraft.stone_shovel": "Pale di piere",
  "item.minecraft.stone_spear": "Lance di piere",
  "item.minecraft.stone_sword": "Spade di piere",
  "item.minecraft.stray_spawn_egg": "Ûf di nassite dal scheletri vagabont",
  "item.minecraft.strider_spawn_egg": "Ûf di nassite dal strider",
  "item.minecraft.string": "Cuardute",
  "item.minecraft.sugar": "Sucar",
  "item.minecraft.suspicious_stew": "Sope suspiete",
  "item.minecraft.sweet_berries": "Pomulis dolcis",
  "item.minecraft.tadpole_bucket": "Seglot cun cudul",
  "item.minecraft.tadpole_spawn_egg": "Ûf di nassite dal cudul",
  "item.minecraft.tide_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornament cun stîl maree",
  "item.minecraft.tipped_arrow": "Frece imbombade",
  "item.minecraft.tipped_arrow.effect.awkward": "Frece imbombade",
  "item.minecraft.tipped_arrow.effect.empty": "Frece imbombade no fabricabile",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Frece di resistence al fûc",
  "item.minecraft.tipped_arrow.effect.harming": "Frece di dam",
  "item.minecraft.tipped_arrow.effect.healing": "Frece di cure",
  "item.minecraft.tipped_arrow.effect.infested": "Frece di infestazion",
  "item.minecraft.tipped_arrow.effect.invisibility": "Frece di invisibilitât",
  "item.minecraft.tipped_arrow.effect.leaping": "Frece di salt",
  "item.minecraft.tipped_arrow.effect.levitation": "Frece di levitazion",
  "item.minecraft.tipped_arrow.effect.luck": "Frece di fortune",
  "item.minecraft.tipped_arrow.effect.mundane": "Frece imbombade",
  "item.minecraft.tipped_arrow.effect.night_vision": "Frece di vision noturne",
  "item.minecraft.tipped_arrow.effect.oozing": "Frece di secrezion",
  "item.minecraft.tipped_arrow.effect.poison": "Frece invelenade",
  "item.minecraft.tipped_arrow.effect.regeneration": "Frece di rigjenerazion",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Frece dal colâ planc",
  "item.minecraft.tipped_arrow.effect.slowness": "Frece di lentece",
  "item.minecraft.tipped_arrow.effect.strength": "Frece di fuarce",
  "item.minecraft.tipped_arrow.effect.swiftness": "Frece di rapiditât",
  "item.minecraft.tipped_arrow.effect.thick": "Frece imbombade",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Frece dal mestri copasse",
  "item.minecraft.tipped_arrow.effect.water": "Frece di aghe",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Frece di respîr te aghe",
  "item.minecraft.tipped_arrow.effect.weakness": "Frece di debilece",
  "item.minecraft.tipped_arrow.effect.weaving": "Frece di tiessidure",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Frece di cjarie di aiar",
  "item.minecraft.tnt_minecart": "Carel minerari cun TNT",
  "item.minecraft.torchflower_seeds": "Semencis di rose-torce",
  "item.minecraft.totem_of_undying": "Totem de imortalitât",
  "item.minecraft.trader_llama_spawn_egg": "Ûf di nassite dal lama di marcjadant",
  "item.minecraft.trial_key": "Clâf de prove",
  "item.minecraft.trident": "Fossigne",
  "item.minecraft.tropical_fish": "Pes tropicâl",
  "item.minecraft.tropical_fish_bucket": "Seglot cun pes tropicâl",
  "item.minecraft.tropical_fish_spawn_egg": "Ûf di nassite dal pes tropicâl",
  "item.minecraft.turtle_helmet": "Casc di copasse",
  "item.minecraft.turtle_scute": "Scus di copasse",
  "item.minecraft.turtle_spawn_egg": "Ûf di nassite de copasse",
  "item.minecraft.vex_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornament cun stîl vex",
  "item.minecraft.vex_spawn_egg": "Ûf di nassite dal vex",
  "item.minecraft.villager_spawn_egg": "Ûf di nassite dal paisan",
  "item.minecraft.vindicator_spawn_egg": "Ûf di nassite dal svindicadôr",
  "item.minecraft.wandering_trader_spawn_egg": "Ûf di nassite dal vendidôr ambulant",
  "item.minecraft.ward_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornament cun stîl vuardie",
  "item.minecraft.warden_spawn_egg": "Ûf di nassite de vuardie",
  "item.minecraft.warped_fungus_on_a_stick": "Baston cun fonc disnaturât",
  "item.minecraft.water_bucket": "Seglot di aghe",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornament cun stîl esploradôr",
  "item.minecraft.wheat": "Forment",
  "item.minecraft.wheat_seeds": "Semencis di forment",
  "item.minecraft.white_bundle": "Sacut blanc",
  "item.minecraft.white_dye": "Tinture blancje",
  "item.minecraft.white_harness": "Imbragadure blancje",
  "item.minecraft.wild_armor_trim_smithing_template": "Model par fari",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornament cun stîl salvadi",
  "item.minecraft.wind_charge": "Cjarie di aiar",
  "item.minecraft.witch_spawn_egg": "Ûf di nassite de strie",
  "item.minecraft.wither_skeleton_spawn_egg": "Ûf di nassite dal scheletri wither",
  "item.minecraft.wither_spawn_egg": "Ûf di nassite dal Wither",
  "item.minecraft.wolf_armor": "Armadure pal lôf",
  "item.minecraft.wolf_spawn_egg": "Ûf di nassite dal lôf",
  "item.minecraft.wooden_axe": "Manarie di len",
  "item.minecraft.wooden_hoe": "Sape di len",
  "item.minecraft.wooden_pickaxe": "Picon di len",
  "item.minecraft.wooden_shovel": "Pale di len",
  "item.minecraft.wooden_spear": "Lance di len",
  "item.minecraft.wooden_sword": "Spade di len",
  "item.minecraft.writable_book": "Libri e pene",
  "item.minecraft.written_book": "Libri scrit",
  "item.minecraft.yellow_bundle": "Sacut zâl",
  "item.minecraft.yellow_dye": "Tinture zale",
  "item.minecraft.yellow_harness": "Imbragadure zale",
  "item.minecraft.zoglin_spawn_egg": "Ûf di nassite dal zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ûf di nassite dal cjaval zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ûf di nassite dal nautil zombi",
  "item.minecraft.zombie_spawn_egg": "Ûf di nassite dal zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Ûf di nassite dal paisan zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Ûf di nassite dal piglin zombificât"
}
export const fur_it = items; 
